<template>
  <div
    class="editPage"
    :class="[
      request_prefix === 'bigScreen' ? '' : 'editPageHome',
      isClonePattern || isOrderPattern ? 'clone-pattern-editpage' : '',
      showEditShape || showRightToolbar ? 'focus-editpage' : '',
      showRightToolbar && !showEditShape ? 'show-right-toolbar' : '',
      $store.state[request_prefix].page.isWaterFall === 'waterFall'?'editPage-waterFall':''
    ]"
    @click="pageClick($event)"
  >
    <TopOperation
      ref="topOperation"
      v-if="request_prefix !== 'bigScreen'"
      :headerSource="headerSource"
      @syncData="syncBtnData"
      @getPreviewUrl="getPreviewUrlHandle"
    ></TopOperation>
    <TopOperationBigScreen
      ref="bigScreenTopOperation"
      v-else-if="request_prefix === 'bigScreen'"
      :headerSource="headerSource"
      @changeSize="changeContainerSize"
    ></TopOperationBigScreen>
    <div :style="{ bottom: request_prefix === 'bigScreen' ? '36px' : '0' }" class="middle-container flex">
      <div
        v-if="!subPagePreview"
        class="menu"
        :class="!showAllScreen && request_prefix === 'stage' ? 'all-absolute' : ''"
      >
        <span
          class="fold-btn icon-portal-arrow-left"
          :class="[showLeftMenus ? '' : 'rotate180']"
          @click="foldMenu"
        ></span>
        <div class="left-menu-wrap" :class="showLeftMenus ? '' : 'fold'">
          <component
            :is="request_prefix === 'bigScreen' ? 'LeftMenuBigScreen' : 'LeftMenu'"
            :menuSource="menuSource"
          ></component>
        </div>
      </div>
      <!-- 移动端可编辑的背景区域不同 -->
      <div
        class="edit_bg scrollbar"
        :class="request_prefix === 'appStage' ? 'app_edit_bg' : ''"
        ref="editPage"
        @click.self="editBgClick"
        id="editPage"
        :style="request_prefix !== 'appStage' ? defaultEditBgColor : ''"
      >
        <vue-ruler-tool
          class="scrollbar"
          ref="content_p_w"
          id="vueRulerContainer"
          :class="{ left_0: !showLeftMenus, right_0: !showRightToolbar, isPhoneFullPage: isPhoneFullScreen }"
          v-model="presetLine"
          :parent="true"
          :parentH="parentH"
          :parentW="parentW"
          :zoom="zoomActual"
          :contentScrollLeft="scrollLeft"
          :contentScrollTop="scrollTop"
          :contentWidth="contentWidth"
          :rulerThickness="rulerThickness"
          :is-scale-revise="true"
          :visible.sync="visible"
          :appEditWidth="APPEDITWIDTH"
          @lineClickEv="lineClick"
          @rulerClickEv="rulerClick"
        >
          <el-scrollbar
            id="pageScollbar"
            ref="scrollbar"
            style="height: 100%;width: 100%"
            :class="{ bg_scrollbar: request_prefix === 'bigScreen', 'zoom-scrolling': zoomScrolling }"
          >
            <div class="page-shade" @click.self.stop="changeElemetnType"></div>
            <div
              :class="[
                request_prefix === 'appStage' ? 'content_p_helper_app' : 'content_p_helper',
                subPagePreview ? 'subPage-Preview' : ''
              ]"
              :style="getEditPageSize"
            >
              <div
                ref="content_p"
                :class="request_prefix === 'appStage' ? 'edit_stage_app' : 'edit_stage'"
                :style="
                  request_prefix === 'appStage' || request_prefix === 'stage' ? getEditPageStyleStage : getEditPageStyleScreen
                "
              >
                <div
                  :class="dataSource.misicPosition === 'left' ? 'audio-box audioLeft' : 'audio-box audioRight'"
                  v-show="request_prefix !== 'bigScreen' && dataSource && dataSource.bgMusicSrc"
                >
                  <span class="audio-stop" @click="musicPlay" v-if="isMusicStop"></span>
                  <span class="audio-play" @click="musicStop" v-else></span>
                  <audio ref="bgMusic" :loop="dataSource.bgMusicLoop" @ended="musicEnd" preload="auto">
                    <source :src="dataSource.bgMusicSrc" />
                  </audio>
                </div>
                <div
                  v-if="dataSource.stageType === 'layOut'"
                  style="width: 100%; height: 100%; position: relative; overflow: hidden"
                >
                  <layoutStage
                    @contextmenuHandle="contextmenuHandle"
                    :layoutOption="dataSource.layoutOption"
                    :zoom="zoomActual"
                    @contextmenu="contextmenuHandle"
                  />
                </div>
                <div
                  v-else
                  :class="isPhoneFullScreen ? 'page-turn-mode' : ''"
                  :style="isPhoneFullScreen ? 'width:' + APPEDITWIDTH + 'px' : ''"
                >
                  <!-- 移动端翻页模式的辅助线 -->
                  <span v-if="isPhoneFullScreen" class="reference-line top-all-line">全面屏</span>
                  <span v-if="isPhoneFullScreen" class="reference-line top-regular-line">常规屏</span>
                  <span v-if="isPhoneFullScreen" class="reference-line bottom-all-line">全面屏</span>
                  <span v-if="isPhoneFullScreen" class="reference-line bottom-regular-line">常规屏</span>
                  <div class="right-handle-btns" v-if="isPhoneFullScreen" @click.stop>
                    <el-tooltip class="item" :hide-after="1000" effect="dark" content="上一页" placement="right">
                      <span class="icon icon-Union-12 rotate180" @click="prevPage"></span>
                    </el-tooltip>
                    <el-tooltip class="item" :hide-after="1000" effect="dark" content="下一页" placement="right">
                      <span class="icon icon-Union-12" @click="nextPage"></span>
                    </el-tooltip>
                    <!-- 别删除  用于后期添加翻页动画的编辑页预览 -->
                    <!-- <el-tooltip
                      v-if="!isEditMode"
                      class="item"
                      :hide-after="1000"
                      effect="dark"
                      content="预览动画"
                      placement="right"
                      v-show="animateOrder !== 'play'"
                    >
                      <span class="icon icon-portal-play" @click="playAnimate"></span>
                    </el-tooltip>
                    <el-tooltip
                      v-if="!isEditMode"
                      class="item"
                      :hide-after="1000"
                      effect="dark"
                      content="停止动画"
                      placement="right"
                      v-show="animateOrder === 'play'"
                    >
                      <span class="icon icon-portal-stop" @click="stopAnimate"></span>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      :hide-after="1000"
                      effect="dark"
                      :content="isEditMode ? '预览模式' : '编辑模式'"
                      placement="right"
                    >
                      <span class="icon" @click="changeEditMode">模式</span>
                    </el-tooltip> -->
                  </div>
                  <template v-if="isLayout">
                    <!-- 新画布 -->
                    <page-layout-stage
                      v-if="!this.$store.state.states.loadingSyncPlugins"
                      :id="dataSource.children[0].container_id"
                      :scrollLeft="scrollLeft"
                      :scrollTop="scrollTop"
                      :contentWidth="contentWidth"
                      :rulerThickness="rulerThickness"
                      :zoom="zoomActual"
                      :appEditWidth="APPEDITWIDTH"
                      @contextmenu="contextmenuHandle"
                      @clickContainer="clickHandle"
                      @clickVdr="vdrClickHandle"
                      @parentContextmenuHandle = "contextmenuHandle"
                      :containerOptions="dataSource.children[0].options"
                      @openSystemLayoutDialog="openSystemLayoutDialog"
                    >
                    </page-layout-stage>
                  </template>
                  <template v-else>
                    <component
                      :is="request_prefix === 'bigScreen' ? 'stageBigScreen' : 'stage'"
                      v-for="(container, index) in dataSource.children"
                      :key="container.container_id"
                      :index="index"
                      :id="container.container_id"
                      :class="containerClass(container, index)"
                      :isBigScreen="request_prefix === 'bigScreen'"
                      :isActive="container.isActive"
                      :width="getStageWidth(container)"
                      :height="Number(container.height)"
                      :scrollLeft="scrollLeft"
                      :scrollTop="scrollTop"
                      :contentWidth="contentWidth"
                      :rulerThickness="rulerThickness"
                      :zoom="zoomActual"
                      :style="getStageStyle(container, index)"
                      :stageType="dataSource.stageType"
                      :children="container.children"
                      :parentElement="container"
                      :containerOptions="getPrimaryStage(container)"
                      :appEditWidth="APPEDITWIDTH"
                      @contextmenu="contextmenuHandle"
                      @clickContainer="clickHandle"
                      @clickVdr="vdrClickHandle"
                    >
                    </component>
                  </template>

                  <!-- 预览模式时，屏蔽掉一系列的编辑事件，加透明遮罩-->
                  <!--                <div v-if="!isEditMode" id="scanShade" @click.self></div>-->
                </div>
              </div>
            </div>
            <div v-if="showSmartServices" class="robot-div" @click.stop="smartClick" :class="getRobotClass">
              <div class="page-layout-sets new-btn-groups is_top" @click.stop>
                <div class="set-groups-wrap">
                  <div class="set-groups handle-btn-name" @click.stop="smartClick">
                    <span class="icon icon-portal-setting1"></span>
                  </div>
                </div>
              </div>
              <img class="img-box" :src="robotCover" alt="" />
            </div>
          </el-scrollbar>
        </vue-ruler-tool>
      </div>
      <div></div>
      <div
        class="right-toolbar"
        :class="
          (!showAllScreen && request_prefix === 'stage') || (request_prefix === 'appStage' && showRightToolbar)
            ? 'all-absolute'
            : ''
        "
      >
        <span
          v-if="!subPagePreview"
          class="fold-btn icon-portal-arrow-right"
          :class="[showRightToolbar ? '' : 'rotate180']"
          @click="foldToolbar(false)"
        ></span>
        <div class="right-toolbar-wrap" :class="showRightToolbar || subPagePreview ? '' : 'fold'">
          <component
            :is="request_prefix === 'bigScreen' ? 'bigScreenToolbar' : 'Toolbar'"
            @save="saveWebjson"
          ></component>
          <!--          <Toolbar></Toolbar>-->
          <!--右键菜单 -->
          <div
            class="right-menu-container"
            v-if="showRightBtn"
            @click="showRightBtn = false"
            @contextmenu.prevent="showRightBtn = false"
          >
            <teleport-comp to="body" :class="request_prefix == 'bigScreen' ? 'bigScreen' : 'home'">
              <div
                @click.stop.prevent
                class="rightMenuDialog"
                v-if="showRightBtn"
                :style="{ top: mouseY, left: mouseX }"
              >
                <ul>
                  <li
                    v-if="showComponentCopy"
                    :class="showPaste ? 'item' : 'item item-split-border'"
                    @click="copyComponent"
                  >
                    <span class="icon icon-portal-copy-small1"></span>复制
                  </li>
                  <!-- 布局的复制和单元格的复制-->
                  <li
                    v-if="showLayoutSet || showCellSet || showColSet"
                    :class="showPaste ? 'item' : 'item item-split-border'"
                    @click="pageLayoutClick(2)"
                  >
                    <span class="icon icon-portal-copy-small1"></span>复制
                  </li>
                  <li v-if="showPaste" class="item item-split-border" @click="pasteComponent">
                    <span class="icon icon-portal-paste"></span>粘贴
                  </li>
                  <li
                    v-show="showCopy && request_prefix === 'bigScreen'"
                    class="item item-split-border"
                    @click="collect"
                  >
                    <span class="icon icon-portal-collection"></span>收藏
                  </li>
                  <li
                    v-if="canUploadStyleToSystem"
                    v-show="showCopy || showLayoutSet"
                    class="item"
                    @click="setSystemStyle(0)"
                  >
                    <span class="icon icon-portal-upload-3"></span>设为系统模块
                  </li>
                  <li
                    v-show="showCollect"
                    class="item item-split-border"
                    @click="setSystemStyle(1)"
                  >
                    <span class="icon icon-portal-collection"></span>收藏到我的样式
                  </li>
                  <li v-show="showLayoutSet && request_prefix === 'stage'" class="item" @click="pageLayoutClick(3)">
                    <span class="icon icon-portal-refresh1"></span>同步到移动端
                  </li>
                  <li
                    v-show="showLayoutSet && request_prefix === 'stage' && managerType === 1"
                    class="item"
                    @click="pageLayoutClick(6)"
                  >
                    <span class="icon icon-portal-sync-default"></span>同步原始样式
                  </li>
                  <li
                    v-show="showLayoutSet && request_prefix === 'stage'"
                    class="item item-split-border"
                    @click="pageLayoutClick(4)"
                  >
                    <span class="icon icon-portal-add-to-app"></span>新增到移动端
                  </li>
                  <li
                    v-show="showLayoutSet && request_prefix === 'stage'"
                    class="item item-split-border"
                    @click="pageLayoutClick(7)"
                  >
                    <span class="icon icon-portal-icon_copy-link"></span>复制链接
                  </li>
                  <li
                    v-if="canUploadStyleToSystem"
                    v-show="showCopy && $route.path === '/appHome'"
                    class="item item-split-border"
                    @click="setMobileSystemStyleToPc"
                  >
                    <span class="icon icon-portal-lock"></span>标记移动端系统样式
                  </li>
                  <li v-if="showGroup && !isLayout" class="item item-split-border" @click="inGroup">
                    <span class="icon icon-portal-group"></span>编组
                  </li>
                  <li v-if="showCancelGroup" class="item item-split-border" @click="cancleGroup">
                    <span class="icon icon-portal-group"></span>取消编组
                  </li>
                  <li v-show="showLevel1" class="item" @click="upperLevel1">
                    <span class="icon icon-portal-up2"></span>移到顶层
                  </li>
                  <li v-show="showLevel1" class="item item-split-border" @click="lowerLevel1">
                    <span class="icon icon-portal-down2"></span>移到底层
                  </li>
                  <li v-show="showCopy && request_prefix !== 'bigScreen'" class="item" @click="upperLevel">
                    <span class="icon icon-portal-up2"></span>上移一层
                  </li>
                  <li
                    v-show="showCopy && request_prefix !== 'bigScreen'"
                    class="item item-split-border"
                    @click="lowerLevel"
                  >
                    <span class="icon icon-portal-down2"></span>下移一层
                  </li>
                  <li v-show="(showCellSet || showColSet) && !isTabPageLayout" class="item" @click="pageLayoutClick(4)">
                    <span class="icon icon-portal-round-add"></span>添加列
                  </li>
                  <li v-show="showRectInfo" class="item item-split-border" @click="showRectInfoClick">
                    <span class="icon icon-portal-round-add"></span>组件信息
                  </li>
                  <li
                    v-show="
                      (showCopy || showLayoutSet || showCellSet || showColSet) && !isTabPageLayout && !isBayWindow && judgePageLayoutCanDelOrCopy()
                    "
                    class="item"
                    @click="del"
                  >
                    <span class="icon icon-portal-delete"></span>删除
                  </li>
                </ul>
              </div>
            </teleport-comp>
          </div>
          <!-- 保存模块对话框 -->
          <el-dialog
            title="收藏的名称"
            :visible.sync="dialogFormVisible"
            :modal-append-to-body="false"
            custom-class="collectDialog"
          >
            <div>
              <el-input v-model="collectModuleForm.name" placeholder="请输入收藏的名称"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
              <el-button size="small" type="primary" @click="saveModuleEv">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 设为系统样式、模块对话框 -->
          <el-dialog
            :title="dialogFormVisible2Title"
            :visible.sync="dialogFormVisible2"
            :modal-append-to-body="false"
            :append-to-body="dialogFormVisible2AppendToBody"
            custom-class="collectDialog"
          >
            <div v-if="!collectStatusNew">
              <cx-select
                @change="changeComponentType"
                title="组件类别"
                :selectOptions="componentTypes"
                :value.sync="systemComponentId"
              />
            </div>
            <div class="mt16" v-if="!collectStatusNew">
              <cx-select title="样式分类" :selectOptions="subComponentTypes" :value.sync="systemComponentType" />
            </div>
            <div class="verticallyCenter" :class="collectStatusNew ? '' : 'mt16'">
              <span class="w74" v-if="!collectStatusNew">组件名称</span>
              <el-input class="flex1" v-model="systemModuleForm.name" placeholder="请输入名称"></el-input>
            </div>
            <div class="mt16 verticallyTop" v-if="!collectStatusNew">
              <span class="w74">上传封面</span>
              <img-upload
                class="flex1"
                :imgSrc.sync="systemComponentCover"
                :noImgLib="false"
                :imgSize="200 + '*' + 220"
              />
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
              <el-button size="small" type="primary" @click="saveSystemModuleEv">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 设为系统通栏样式、模块对话框 -->
          <updateSystemLayoutStyle
            :dialogSystemLayout.sync="dialogSystemLayout"
            :isCollectSystemLayout="isCollectSystemLayout"
            :selectPageLayout="selectPageLayout"
          />
          <editComponentId
            :dialogEditComponentId.sync="dialogEditComponentId"
            :curRectInfo="curRectInfo"
          />
        </div>
      </div>
    </div>
    <div class="bottom" :style="{ display: request_prefix === 'bigScreen' ? '' : 'none' }">
      <div class="floatRight verticallyCenter">
        <span class="icon icon-portal-adapt mr8" @click="adaptEditPage"></span>适应画布
      </div>
      <div class="floatRight verticallyCenter mr24">
        <span class="zoomIcon icon-portal-zoom-out" @click="zoomEditPage('zoomOut')"></span>
        <el-slider
          style="width: 204px; height: 4px"
          class="zoom-slider"
          v-model="zoom"
          :min="minZoom"
          :max="maxZoom"
          :step="0.01"
          :format-tooltip="formatTooltip"
          :show-tooltip="false"
          :change="zoomCanvas(zoom)"
        >
        </el-slider>
        <span class="zoomText">
          <input type="text" v-model="zoomVal" />
          <span>%</span>
        </span>
        <span class="zoomIcon icon-portal-zoom-in" @click="zoomEditPage('zoomIn')"></span>
      </div>
      <div class="floatRight verticallyCenter">
        <span class="icon icon-portal-help1 mr8 theme-color pointer" @click="gotoHelpCenter"> 帮助中心</span>
      </div>
    </div>
    <!-- 单元格 克隆操作按钮 -->
    <div v-if="isClonePattern" id="syncBtn" class="verticallyCenter">
      <span class="icon icon-portal-clone"></span>
      <span class="flex1">克隆样式</span>
      <span class="clone-btn" @click="syncCol">完成</span>
    </div>
    <!-- 单元格 排序操作按钮 -->
    <div v-if="isOrderPattern" id="syncBtn" class="verticallyCenter">
      <span class="icon icon-portal-click"></span>
      <span class="flex1">请按顺序点击单元格</span>
      <span class="clone-btn clone-btn--normal" @click="cancelOrder">取消</span>
      <span class="clone-btn clone-btn--normal" @click="resetOrder">清空</span>
      <span class="clone-btn" @click="saveOrder">完成</span>
    </div>
    <iframe id="loadSsrPageIframe" v-if="iframePreviewUrl" ref="previewIframe" :src="iframePreviewUrl"></iframe>
  </div>
</template>

<style scoped>
.robot-div {
  position: fixed;
  z-index: 9999;
  right: 260px;
  bottom: 100px;
  width: 80px;
  height: 80px;
}
.robot-div.select-active::before {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px dashed var(--themeColor);
}
.robot-div .new-btn-groups {
  display: none;
}
.robot-div.select-active .new-btn-groups {
  display: block;
}
.robot-div .is_top {
  position: absolute;
  bottom: 100%;
}
.robot-div .img-box {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.right-menu-container {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
}
.w74 {
  display: inline-block;
  width: 74px;
}
::v-deep .el-scrollbar__wrap {
  height: calc(100% + 20px);
  margin-bottom: 0 !important;
}
::v-deep .isPhoneFullPage .el-scrollbar__wrap {
  overflow: hidden;
  height: 762px;
  width: 100%;
}
::v-deep .zoom-scrolling .el-scrollbar__wrap {
  overflow: hidden;
}
::v-deep .bg_scrollbar {
  width: calc(100% - 24px);
}
::v-deep .el-scrollbar__view {
  position: relative;
  display: inline-block;
  min-width: 100%;
}
::v-deep .el-scrollbar__bar {
  bottom: 6px;
}
::v-deep .el-scrollbar__bar {
  z-index: 10000;
}
body {
  background-color: #ececec;
  margin: 0;
  color: rgba(255, 255, 255, 0.4);
}
.vue-ruler-wrapper {
  padding-top: 24px;
}
.left-menu-wrap {
  width: 240px;
  padding: 0;
  box-sizing: border-box;
}
.editPageHome .left-menu-wrap {
  width: 220px;
  box-shadow: 1px 0 #e9e9e9;
}
.right-toolbar-wrap {
  width: 260px;
}
.right-toolbar,
.menu {
  position: relative;
  height: 100%;
  transition: width 0.1s;
  z-index: 100;
}
.right-toolbar.all-absolute,
.menu.all-absolute {
  position: absolute;
}
.menu.all-absolute {
  left: 0;
}
.right-toolbar.all-absolute {
  right: 0;
}
.right-toolbar-wrap {
  height: 100%;
}
.left-menu-wrap {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  -ms-overflow-style: none; /* IE 10+ */
}

.right-toolbar-wrap.fold,
.left-menu-wrap.fold {
  display: block;
  width: 0;
  padding: 0;
  overflow: hidden;
}
.rotate180 {
  transform: rotate(180deg);
}
.edit_bg {
  position: relative;
  margin-top: 0 !important;
  height: 100% !important;
}
.editPageHome .edit_bg {
  background: #f7f8fa;
}
.edit_stage_app {
  box-shadow: 0px 0px 12px 0px #0000000a;
}
.editPageHome ::v-deep .vue-ruler-v {
  left: 0;
  top: 24px;
}
.editPageHome .middle-container {
  top: 50px;
}
.editPageHome ::v-deep .vue-ruler-h {
  top: 0;
  left: 24px;
}
.menu .fold-btn,
.right-toolbar .fold-btn,
.edit_bg .fold-btn {
  position: absolute;
  top: 37px;
  color: var(--selectArrorIcon);
  width: 24px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  background-color: var(--leftMenuBgColor);
  z-index: 9999;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 8px 20px rgba(0, 0, 0, 0.12);
}
.menu .fold-btn:hover,
.right-toolbar .fold-btn:hover,
.edit_bg .fold-btn:hover {
  color: var(--themeColor);
}
.edit_bg .fold-btn.rotate180 {
  transform: rotate(180deg);
}
.menu .icon-portal-arrows-left {
  right: -60px;
}
.edit_bg .icon-portal-arrows-left {
  left: 25px;
}
.right-toolbar .icon-portal-arrows-right {
  left: -37px;
}
.edit_bg .icon-portal-arrows-right {
  right: 25px;
}
.edit_bg {
  position: relative;
  height: 772px;
  flex: 1;
  margin-top: 84px;
  overflow: hidden;
}
.content_p_helper_app {
  position: relative;
  margin: 0 auto;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.04);
}
.content_p_helper_app.subPage-Preview {
  left: 0;
}

.bottom {
  position: absolute;
  bottom: 0;
  z-index: 999;
  height: 36px;
  width: 100%;
  padding: 5px 340px 5px 20px;
  box-sizing: border-box;
  /* color: rgba(255, 255, 255, 0.4); */
  color: var(--thirdTextColor);
}
.bottom .zoomIcon {
  font-size: 18px;
  margin: 0 10px;
  cursor: pointer;
}
.bottom .icon:before {
  color: inherit;
}
.bottom .icon-portal-adapt {
  cursor: pointer;
}
.zoom-slider {
  position: relative;
}
.zoom-slider/deep/ .el-slider__button {
  border: none;
  background: var(--pageBottomSliderBg);
}
.zoom-slider/deep/ .el-slider__bar {
  background: transparent;
}
.el-slider::after {
  width: 4px;
  height: 6px;
  content: "";
  /* background: #000; */
  background: var(--leftMenuBgColor);
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -2px;
}
.zoomText {
  display: inline-block;
  width: 50px;
  margin-left: 20px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
.zoomText * {
  display: inline-block;
  vertical-align: middle;
}
.zoomText input {
  display: inline-block;
  width: 30px;
  text-align: center;
  color: var(--thirdTextColor);
  background-color: transparent;
}
.left_0 /deep/.vue-ruler-h {
  left: 24px;
}
.left_0 /deep/.vue-ruler-v {
  left: 0;
}
.right_0 /deep/.vue-ruler-h,
.right_0 /deep/.vue-ruler-v {
  right: 0;
}
.middle-container {
  position: absolute;
  width: 100%;
  top: 60px;
}
::v-deep .myContainer {
  background-color: transparent;
  border: 1px solid transparent;
}

.bottom {
  background-color: var(--leftMenuBgColor);
}
::v-deep .vue-ruler-content .vue-ruler-h {
  position: absolute;
  top: -24px;
  left: 0;
  width: 100%;
  text-align: center;
}
.rightMenuDialog .icon {
  margin-right: 8px;
  font-size: 14px;
}
.rightMenuDialog .item-split-border {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.page-turn-mode {
  position: relative;
  /*width: 375px;*/
  height: 762px;
}
.page-turn-mode .myContainer {
  position: absolute;
  top: 0;
  left: 0;
}
.reference-line {
  position: absolute;
  z-index: 9999;
  width: 462px;
  height: 0;
  right: 0;
  border-top: 1px dashed rgba(181, 186, 193, 1);
  color: #b5bac1;
}
.top-all-line {
  top: 0;
}
.top-regular-line {
  top: 50px;
}
.bottom-all-line {
  bottom: 0;
}
.bottom-regular-line {
  bottom: 50px;
}
.right-handle-btns {
  position: absolute;
  right: -40px;
  z-index: 1000;
  width: 30px;
}
.right-handle-btns .icon {
  display: inline-block;
  width: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.6);
}
.right-handle-btns .icon-portal-stop {
  font-size: 21px;
}
.right-handle-btns .icon:hover {
  background-color: var(--iconHoverBgColor);
}
#scanShade {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
  background-color: rgba(0, 0, 0, 0);
}
.home .rightMenuDialog .item-split-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.audio-box {
  position: absolute;
  z-index: 999;
  top: 10px;
}
.audioLeft {
  left: 10px;
}
.audioRight {
  right: 10px;
}
.audio-box .audio-play {
  display: block;
  width: 24px;
  height: 24px;
  background-image: url(../assets/images/music-on.png);
  background-size: 100%;
  cursor: pointer;
  animation: audio-animation 3s infinite linear;
}
@keyframes audio-animation {
  100% {
    transform: rotate(360deg);
  }
}
.audio-box .audio-stop {
  display: block;
  width: 24px;
  height: 24px;
  background-image: url(../assets/images/music-off.png);
  background-size: 100%;
  cursor: pointer;
}
.syncBtn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px;
  position: absolute;
  right: -24px;
  width: 24px;
  height: 96px;
  font-size: 14px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}
.syncBtn:hover {
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}
.menu .fold-btn,
.right-toolbar .fold-btn {
  top: 4px;
  width: 26px;
  height: 26px;
  line-height: 26px;
  font-size: 18px;
  background-color: transparent;
  box-shadow: none;
}
.menu .icon-portal-arrow-left {
  right: 8px;
}
.right-toolbar .icon-portal-arrow-right {
  left: 234px;
}

.menu .icon-portal-arrow-left.rotate180 {
  right: -26px;
  background: #1f2124;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px 0px 0px 6px;
}
.editPageHome .menu .icon-portal-arrow-left.rotate180 {
  background: #fcfcfc;
  border: 1px solid #e8e8e8;
}
.right-toolbar .icon-portal-arrow-right.rotate180 {
  left: -26px;
  background: #1f2124;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 0 6px 6px 0;
}
.editPageHome .right-toolbar .icon-portal-arrow-right.rotate180 {
  background: #fcfcfc;
  border: 1px solid #e8e8e8;
}
.page-shade,
.page_shape {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 0;
}
.page_shape {
  z-index: 10000; /* 仅次于通栏 */
}
#loadSsrPageIframe{
  margin-left: -500px;
}
</style>

<script>
import { primaryAppStageGenerator as primaryappStageGenerator } from "../store/modules/appStage/state"
import { primaryBigScreenGenerator as primarybigScreenGenerator } from "../store/modules/bigScreen/state"
import { primaryStageGenerator as primarystageGenerator } from "../store/modules/stage/state"
import { VDRAttribute } from "../dependencies/base"
import { bigScreen_emptylayout_children } from "dependencies/emptyLayout/index.js"
import { initModules, getSystemModulesList, getSubPageModulesList } from "@/utils/initEv.js"
import { handleChildAppid } from "@/utils/reCreatAppid"
import "../assets/icomoon/style.css"
import "../assets/css/common.css"
import "../assets/css/cx_animate.css"
import "../assets/css/phone_animate.css"
import LeftMenu from "./stageComponents/left-menu/left-menu.vue"
import LeftMenuBigScreen from "./stageComponents/left-menu/left-menu-bigScreen.vue"
import TopOperationBigScreen from "./headComponents/top-operation-bigScreen.vue"
import TopOperation from "./headComponents/top-operation.vue"
import VueRulerTool from "./headComponents/vue-ruler-tool.vue"
import Toolbar from "./stageComponents/toolbar/toolbar.vue"
import bigScreenToolbar from "./stageComponents/toolbar/bigScreen-toolbar.vue"
import cacheComponent from "./elementComponents/cacheComponent/index.vue"
import updateSystemLayoutStyle from "materials/pageLayout/toolbars/update_system_layout_style.vue"
import editComponentId from "./editComponentId.vue"
import $ from "jquery"
import {
  _throttle,
  _debounce,
  encryption,
  getAttrById,
  deepChangeUid,
  handleFindLayoutComponentOptionsCols,
  findParentIds,
  simpleDeepClone,
  smartMathMax,
  replaceUrlParam,
  copyTextToClipboard,
  findPathInComponentLayoutByRectId
} from "utils"
import { deepCloneAndFreeze } from "utils/revork"
import Qs from "qs"
import { data_dictionary_map } from "root/static/dataDictionary"
import layoutStage from "./layoutStage/index.vue"
import pageLayoutStage from "./pageLayoutStage.vue"
import stageBigScreen from "./stage-bigScreen.vue"
import stageAnimate from "./stageAnimate"
import { getTarComponentEvent } from "utils/event"
import animateMixin from "utils/event/animateMixin.js"
import { delAnimateOutCurrentRect, idsFilter, compareIds, objectSize, delAnimateGroup } from "../utils/event/animate"
import { isExist, findCurrentComponentPathInLayoutByRectId } from "../utils"
import { v1 } from "uuid"
import html2canvas from "html2canvas"
import teleportComp from "./teleportComp.js"
import { CATEGORY_MODE } from "@/consts/index.js"
const uuid = { v1 }
export default {
  name: "editPage",
  components: {
    LeftMenu,
    LeftMenuBigScreen,
    VueRulerTool,
    Toolbar,
    bigScreenToolbar,
    TopOperationBigScreen,
    TopOperation,
    cacheComponent,
    layoutStage,
    pageLayoutStage,
    stageBigScreen,
    updateSystemLayoutStyle,
    teleportComp,
    editComponentId
  },
  mixins: [stageAnimate, animateMixin],
  data() {
    return {
      isTabPageLayout: false,
      loaded: false,
      firstLoad: true,
      presetLine: [],
      visible: true,
      isFirstLoadheader: true,
      headerData: {
        html: "",
        type: "header",
        setLink: ""
      },
      minZoom: 0.1,
      maxZoom: 2,
      showCopy: false,
      showPaste: false,
      showGroup: false,
      showRectInfo: false,
      showCancelGroup: false,
      mouseX: undefined,
      mouseY: undefined,
      copyCompontsData: [],
      collectModuleForm: {
        name: null,
        type: 15
      },
      systemModuleForm: {
        name: null,
        type: 1
      },
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible2AppendToBody: false, // 【收藏到我的样式/设为系统模块】弹窗是否插入至 body 元素上
      dialogEditComponentId: false,
      curRectInfo:{}, // 右键组件的信息
      isCollect: 0,
      checkList: [],
      systemComponentType: "",
      systemComponentCover: "",
      ctrlDown: false, // 判断当前是否已经按下了ctrl键
      shiftDown: false,
      isInStage: false,
      isEditMode: true,
      isFirstStageActive: true,
      isMusicStop: true,
      rects: [],
      timerByScroll: null,
      curr: null,
      prev: null,
      subComponentTypes: [],
      allSubComponentTypes: [],
      systemComponentId: null,
      scrollLeft: 0,
      scrollTop: 0,
      rulerThickness: 24, //标尺厚度
      contentWidth: undefined,
      APPEDITWIDTH: 414,
      dialogSystemLayout: false,
      isCollectSystemLayout: false,
      selectPageLayout: null,
      baseComponent: [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        "cxCode",
        "cxAutoLayout",
        "cxDatePicker",
        "cxInput",
        // "cxDataGrid",
        "cxAnchorComponent",
        "cxSort",
        "cxShare"
      ],
      updatePosition: false, //修改位置按键
      pageMouseX: undefined,
      pageMouseY: undefined,
      showLevel1: false,
      showLayoutSet: false, // 通栏右键
      showCellSet: false, // 布局右键
      showColSet: false, // 单元格右键
      offsetX: undefined,
      offsetY: undefined,
      collectNewVersion: true, //是否使用收藏新交互
      collectStatusNew: false, //右键是否点击收藏
      dialogFormVisible2Title: "组件样式上传",
      screenShotting: false,
      zoomScrolling: false, //是否缩放滚动页面中
      pasteIds: null,
      isBayWindow: false,
      basePageWidth: 1920, // 所有的页面基于1920px来构建
      leftMenuWidth: 220, // 左菜单宽度
      rightToolbarWidth: 260, // 右侧设置栏宽度
      iframePreviewUrl: "", // iframe中的预览地址
      isAccordionLayout: false,
      openIndex: -1
    }
  },
  watch: {
    ids: {
      handler(newVal) {
        if (
          (newVal.hasOwnProperty("rect_id") && newVal.rect_id !== null) ||
          (newVal.hasOwnProperty("pageLayoutId") && newVal.pageLayoutId !== null)
        ) {
          // 点击布局的时候 需要显示右键菜单
          // this.isInStage = newVal.pageLayoutId !== null ? false : true
          this.isInStage = true
        } else {
          // 未选中rect的时候清空
          sessionStorage.removeItem("tmpComponents")
          sessionStorage.setItem("tmpComponents", JSON.stringify([]))
        }
        newVal = idsFilter(newVal)
        if (this.shiftDown && newVal.rect_id !== null) {
          let oldTmpComponents = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
          let hasChecked = false // 多选的时候判断是不是一个组件点击了多次
          for (let i = 0; i < oldTmpComponents.length; i++) {
            let isCommon = true
            for (let key in newVal) {
              if (newVal[key] !== oldTmpComponents[i][key]) {
                isCommon = false
                break
              }
            }
            if (isCommon) {
              hasChecked = true
              break
            }
          }
          if (hasChecked) {
            return
          }
          oldTmpComponents.push(newVal)
          console.log("oldTmpComponents", oldTmpComponents)
          sessionStorage.removeItem("tmpComponents")
          sessionStorage.setItem("tmpComponents", JSON.stringify(oldTmpComponents))
          // localStorage.setItem("multipleComponent", true)
        }else{
          sessionStorage.removeItem("tmpComponents")
        }
        if (this.request_prefix === "bigScreen") {
          this.judgeShowRightToolbar()
        }
      },
      deep: true
    },
    showRightToolbar: {
      // 抽屉的遮罩要根据是否显示右侧栏设置不同的宽度
      handler(newVal) {
        const drawer = $(".cutome-drawer-modal")
        if (drawer && drawer.length > 0) {
          if (!newVal) {
            drawer.css("width", "100%")
          } else {
            // 还原宽度
            drawer.css("width", "calc(100% - 480px)")
          }
        }
        this.foldToolbar(true)
      }
    },
    showAllScreen: {
      handler() {
        this.adaptEditPage(true)
        this.$refs.content_p_w.windowResize()
      }
    }
  },
  mounted() {
    //oldActiveDat设置为nothing，用于布局组件内的acitve的辅助判断,首次进入页面未选中任何组件，所以ooldActiveData为空
    window.localStorage.setItem("alignHelperStatus", JSON.stringify(false))
    initModules.call(this)
    this.loaded = true
    this.$nextTick(() => {
      this.isKeyPressed()
      this.contentWidth = document.getElementById("vueRulerContainer").getBoundingClientRect().width
      if (this.request_prefix === "bigScreen") {
        this.adaptEditPage()
      }
      window.addEventListener("resize", this.resetContentWidth)
      //本地环境不更新动画
      if (!this.isPhoneFullScreen && process.env.NODE_ENV !== "development") {
        document
          .getElementById("editPage")
          .getElementsByClassName("el-scrollbar__wrap")[0]
          .addEventListener("scroll", this.handleScroll)
      }
    })
    window.addEventListener("message", this.updateSubPageMapping)
    if (this.request_prefix !== "bigScreen") {
      this.showRightToolbar = false //初始化不显示右侧栏
    }
    if (!this.isPhoneFullScreen) {
      this.$refs.scrollbar.wrap.addEventListener("scroll", this.editScroll)
    }
  },
  beforeDestroy() {
    localStorage.removeItem("multipleComponent")
    if (!this.isPhoneFullScreen && process.env.NODE_ENV !== "development") {
      document
        .getElementById("editPage")
        .getElementsByClassName("el-scrollbar__wrap")[0]
        .removeEventListener("scroll", this.handleScroll)
    }
    window.removeEventListener("resize", this.resetContentWidth)
    document.removeEventListener("keydown", this.keyPressEvent)
    document.removeEventListener("wheel", this.wheelEvent, { passive: false })
    if (!this.isPhoneFullScreen) {
      this.$refs.scrollbar.wrap.removeEventListener("scroll", this.editScroll)
    }
  },
  computed: {
    pageWidth() {
      return this.$store.state[this.request_prefix].page.pageWidth
    },
    showComponentCopy(){
      if(this.ids.cellId && !isExist(this.ids.elementInDataGridId)){
        return false
      }
      this.showCopy = this.ids.rect_id !== null && this.ids.rect_id !== undefined ? true : false
      if(this.showCopy && !this.inWaterGrid && !(this.showLayoutSet || this.showCellSet || this.showColSet) &&
          !this.hideCopy){
       return true
      }
      return  false
    },
    showCollect(){
      if(this.request_prefix === 'bigScreen'){
        return false
      }
      if(this.ids.cellId && !isExist(this.ids.elementInDataGridId)){
        return  false
      }
      if(this.showCopy || this.showLayoutSet){
        return true
      }
      return false
    },
    hideCopy() {
      // 隐藏复制按钮
      let stage = this.$store.state[this.request_prefix]
      let rectAttr = getAttrById(stage, this.ids)
      rectAttr = rectAttr.options ? rectAttr.options : rectAttr
      if (rectAttr?.loginType || rectAttr?.searchType) return true
      return rectAttr?.isPageLayoutTabs // 标签布局下的标签组件
    },
    activeGridId: {
      get() {
        const activeGridId = this.$store.state.states.activeGridId
        if (activeGridId) {
          const vueGridItem = document.getElementsByClassName(`${activeGridId}`)[0]
          const layout = this.getParentNodeByClassName(vueGridItem, [], "layout-columns")[0]
          this.waterFallLayoutId = layout?.getAttribute("layoutindex") || undefined // 栅格所在通栏
        }
        return activeGridId
      },
      set(newVal) {
        this.$store.commit("states/changeActiveGridIdStatus", newVal)
      }
    },
    showCopyPaste() {
      // todo  新的瀑布流模式下只有在自由布局内才允许复制粘贴
      if (this.$store.state[this.request_prefix].page.isWaterFall !== "waterFall") {
        return true
      }
      const elementType = this.$store.state.states.elementType
      if (
        !isExist(this.ids.rect_id) &&
        ["emptyLayoutComponent", "swiperComponent", "layoutComponent"].indexOf(elementType) > -1
      ) {
        return true
      }
      if ((isExist(this.ids.rect_id) && this.ids.uid) || isExist(this.ids.directionIndex)) {
        return true
      }
      return false
    },
    managerType() {
      return this.$store.state.states.managerType
    },
    dataSource() {
      return this.$store.state[this.request_prefix].page
    },
    menuSource() {
      if (this.request_prefix === "appStage") {
        return this.$store.state.appMenu.menu.children
      } else if (this.request_prefix === "bigScreen") {
        return this.$store.state.bigScreenMenu.menu.children
      }
      return this.$store.state.menu.menu.children
    },
    headerSource() {
      return this.$store.state.operation.operation.children
    },
    isLayout() {
      if (this.isPhoneFullScreen) {
        // 翻页模版不能设置为布局模式
        return false
      }
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isOnlyPhonePageFlag() {
      let page = this.$store.state[this.request_prefix].page
      if (page.isPhoneFullScreen || page.isOnlyH5Template) {
        return true
      }
      return false
    },
    canUploadStyleToSystem() {
      let userPermissionCode = this.$store.state.states.userPermission
      return Array.isArray(userPermissionCode) && userPermissionCode?.indexOf(11) > -1 ? true : false
    },
    // 两侧面板浮起
    showAllScreen: {
      get() {
        return this.$store.state.states.showAllScreen
      },
      set(val) {
        this.$store.commit("states/changeShowAllScreenStatus", val)
      }
    },
    getStageWidth() {
      return function (container) {
        if (this.request_prefix == "stage") {
          return this.basePageWidth
        } else if (this.request_prefix == "bigScreen") {
          return container.width
        } else {
          return container.width
        }
      }
    },
    getStageStyle() {
      return function (container, index) {
        if (!this.isPhoneFullScreen) {
          let isFixed = false
          if (
            (container.options?.inDcoument === "header" || container.options?.inDcoument === "footer") &&
            container.options?.isFixed
          ) {
            isFixed = true
          }
          return {
            zIndex: !isFixed ? this.dataSource.children.length - index : ""
          }
        }
        if (!this.isEditMode) {
          return
        }
        let zIndex = null
        if ((container.isActive && !this.autoPlayAnimate) || (this.autoPlayAnimate && this.showStageIndex === index)) {
          zIndex = 1
        }
        return {
          zIndex: zIndex
        }
      }
    },
    activeComponent() {
      let activeObj = null
      this.activeStageData.children.forEach(item => {
        if (item.active === true) {
          activeObj = item
          return
        }
      })
      if (activeObj) {
        this.isInStage = true
      }
      return activeObj
    },
    activeStageData() {
      let activeObj = this.dataSource.children[0]
      for (let key of this.dataSource.children) {
        if (key.isActive) {
          activeObj = key
        }
      }
      return activeObj
    },
    parentH() {
      return Math.ceil(this.dataSource.children[0].height * this.zoom)
    },
    parentW() {
      return Math.ceil(this.dataSource.children[0].width * this.zoom)
    },
    pageLayoutList() {
      return this.$store.state[this.request_prefix].page.pageLayoutList || []
    },
    pageEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    },
    getEditPageSize() {
      if (this.request_prefix === "bigScreen") {
        this.$store.commit("states/changePageZoomActual", this.zoom)
        const { width, height } = this.$store.state[this.request_prefix].page.children[0]
        if(this.$refs.scrollbar) {
          const wrap = this.$refs.scrollbar.wrap.querySelector(".el-scrollbar__view")
          wrap.style.width = width * this.zoom + "px"
          wrap.style.height = height * this.zoom + "px"
        }
        return {
          width: width + "px",
          height: height + "px",
          transform: `scale(${this.zoom})`,
          transformOrigin: "0px 0px"
        }
      }
      const style = {
        width: this.request_prefix !== "appStage" ? "100%" : this.APPEDITWIDTH + "px",
        transform: `scale(${this.zoom})`,
        transformOrigin: "0px 0px"
      }
      if (this.request_prefix !== "stage") {
        this.$store.commit("states/changePageZoomActual", this.zoom)
        style.left = `-${115 * this.zoom}px`
        return style
      }
      let zoom = 1
      let maxLayoutWidth = this.pageWidth
      let editAreaW = 0
      let scrollEditWidth = 0
      if (this.showAllScreen && this.$refs.editPage) {
        editAreaW = this.$refs.editPage.clientWidth
        if (this.showRuler) {
          editAreaW -= 24
        }
        scrollEditWidth = editAreaW
        // 找到最大的通栏宽度
        for (let layout of this.pageLayoutList) {
          if (layout.options.isCustomWidth) {
            maxLayoutWidth = Math.max(maxLayoutWidth, layout.options.width)
          }
        }
        // 版心默认加100，方便选中通栏
        let maxPageWidth = Math.min(maxLayoutWidth + 100, this.basePageWidth)
        if (editAreaW < maxPageWidth) {
          style.width = `${maxPageWidth}px`
          scrollEditWidth = maxPageWidth
        }
        if (maxPageWidth - editAreaW >= 0 && maxPageWidth - editAreaW < 300) {
          zoom = -0.000667 * (maxPageWidth - editAreaW) + 1
        } else if (maxPageWidth - editAreaW >= 300) {
          zoom = 0.8
        }
        zoom = zoom + (this.zoom - editAreaW / this.basePageWidth)
        scrollEditWidth = scrollEditWidth * zoom
      }
      style.transform = `scale(${zoom})`
      // this.$changeOptionsEV('')
      style.transformOrigin = "0px 0px"
      this.$store.commit("states/changePageZoomActual", zoom)
      if (this.$refs.scrollbar && this.request_prefix === "stage") {
        // 手动设置宽度，避免没更新引起的无效滚动条问题
        const wrap = this.$refs.scrollbar.wrap
        if(this.showAllScreen) {
          wrap.querySelector(".el-scrollbar__view").style.width = scrollEditWidth + "px"
        }
        this.$nextTick(() => {
          wrap.scrollTo(wrap.scrollLeft, wrap.scrollTop)
          this.$refs.scrollbar.update()
          if(this.showAllScreen) {
            if (scrollEditWidth - editAreaW > 1) {
              wrap.parentElement.querySelector(
                ".el-scrollbar__bar.is-horizontal .el-scrollbar__thumb"
              ).style.visibility = "visible"
            } else {
              wrap.parentElement.querySelector(
                ".el-scrollbar__bar.is-horizontal .el-scrollbar__thumb"
              ).style.visibility = "hidden"
            }
          }
        })
      }
      return style
    },
    bgStyle() {
      let conatinerBg = {
        backgroundImage: ""
      }
      let containerOptions = this.$store.state[this.request_prefix].page.children[0].options
      if (!containerOptions.background || !Array.isArray(containerOptions.background)) {
        let defalutColor = this.request_prefix === "stage" ? "#fff" : "#00043A"
        // 需要用响应式写法，不然背景色的设置会失效
        this.$set(containerOptions, "background", [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: containerOptions.bgColor || defalutColor
          }
        ])
      }
      containerOptions.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = conatinerBg.backgroundImage.length > 0 ? "," : ""
            conatinerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            conatinerBg.backgroundSize = bg.clipSize
            conatinerBg.backgroundPosition = bg.alignType
            conatinerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            conatinerBg.backgroundColor = bg.isThemeColor
              ? this.$store.state[this.request_prefix].page.themeColor
              : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              conatinerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              conatinerBg.backgroundImage +=
                dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
            }
            break
          default:
        }
      })
      return conatinerBg
    },
    getEditPageStyleScreen() {
      let style = {
        width: '100%',
        height: '100%',
        border: "1px solid var(--themeColor)"
      }
      return { ...style, ...this.bgStyle }
    },
    getEditPageStyleStage() {
      let defaultBg = [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: "#fff"
        }
      ]
      let pageSet = this.$store.state[this.request_prefix].page
      let globalBgSetting
      if (pageSet.globalBgSetting) {
        globalBgSetting = this.checkAndSetPrimaryVal(pageSet.globalBgSetting, "background", "background", defaultBg)
      } else {
        globalBgSetting = this.checkAndSetPrimaryVal(pageSet, "globalBgSetting", "globalBgSetting", {
          background: defaultBg
        }).background
      }
      let opacity =
        pageSet.globalBgSetting && pageSet.globalBgSetting.hasOwnProperty("opacity")
          ? pageSet.globalBgSetting.opacity
          : 100

      let paddingTop = 0
      let isShowHeader = this.$store.state[this.request_prefix].page.isShowHeader
      let header = this.$store.state[this.request_prefix].page.children[0]
      if (isShowHeader && header && header.options?.isFixed && header.options.inDocument === "header") {
        paddingTop = header.height + "px"
      }
      let containerBg = {
        padding: `${paddingTop} 0 0 0 `,
        width: this.request_prefix === "stage" ? "100%" : this.APPEDITWIDTH + "px",
        opacity: opacity / 100,
        backgroundImage: "",
        backgroundSize: "",
        backgroundPosition: "",
        backgroundRepeat: "",
        backgroundColor: ""
      }
      globalBgSetting.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            containerBg.backgroundColor = bg.isThemeColor
              ? this.$store.state[this.request_prefix].page.themeColor
              : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            }
            break
          case "radialGradient":
            if (bg.data.stops.length > 0) {
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage +=
                  dot + "-webkit-radial-gradient(center,closest-corner," + tmp.join(",") + ")"
              }
            }
            break
          default:
        }
      })
      return { ...containerBg }
    },
    defaultEditBgColor() {
      if (this.request_prefix === "bigScreen") {
        return {}
      }
      const DEFAULT_BG = "rgba(255,255,255,1)"
      const pageSet = this.$store.state[this.request_prefix].page
      let backgroundColor
      if (pageSet?.globalBgSetting?.background) {
        const bg = pageSet?.globalBgSetting?.background.find(bg => bg.type === "color")
        backgroundColor = bg.isThemeColor ? pageSet.themeColor : bg.color
        backgroundColor = backgroundColor || DEFAULT_BG
      }
      const opacity =
        pageSet.globalBgSetting && pageSet.globalBgSetting.hasOwnProperty("opacity")
          ? pageSet.globalBgSetting.opacity
          : 100
      return {
        backgroundColor,
        opacity
      }
    },
    zoomVal: {
      get() {
        return parseInt(this.zoom * 100)
      },
      set(val) {
        let zoom = (val / 100).toFixed(2)
        if (zoom != this.zoom) {
          this.zoom = parseFloat(zoom)
        }
      }
    },
    zoom: {
      get() {
        let zoom = this.$store.state.states.zoom
        if (this.showAllScreen && !zoom) {
          // 初始化缩放等于当前可视区域大小
          let pageWidth = document.body.clientWidth
          if (this.showRuler) {
            pageWidth -= 24
          }
          if (this.request_prefix === "stage") {
            pageWidth -= this.leftMenuWidth
            if(this.showRightToolbar) {
              pageWidth -= this.rightToolbarWidth
            }
            zoom = pageWidth / this.basePageWidth
          } else {
            zoom = 1
          }
          this.$store.commit("states/changePageZoom", zoom)
        } else if (!this.showAllScreen && zoom == undefined) {
          //优化存在zoom为undefined的情况
          zoom = 1
        }
        return zoom
      },
      set(val) {
        this.$store.commit("states/changePageZoom", val)
      }
    },
    zoomActual() {
      return this.$store.state.states.zoomActual
    },
    showRightBtn: {
      get() {
        return this.$store.state.states.showRightBtn
      },
      set(newVal) {
        this.$store.commit("states/changeRightBtnStatu", newVal)
      }
    },
    showRightMenu: {
      get() {
        return this.$store.state.states.showRightMenu
      },
      set(newVal) {
        this.$store.commit("states/changeShowRightMenuStatus", newVal)
      }
    },
    showRuler() {
      if (this.request_prefix === "bigScreen") {
        return this.$store.state.states.showRuler || true
      }
      // 因为门户这边的参数是反的
      return !this.$store.state.states.showRuler || false
    },
    showLeftMenus: {
      get() {
        return this.$store.state.states.showLeftMenus
      },
      set(newVal) {
        this.$store.commit("states/changeShowLeftMenusStatus", newVal)
      }
    },
    showRightToolbar: {
      get() {
        return this.$store.state.states.showRightToolbar
      },
      set(newVal) {
        this.$store.commit("states/changeShowRightToolbarStatus", newVal)
      }
    },
    ids: {
      get() {
        return this.$store.state.states.activeID
      },
      set(newVal) {
        this.$store.commit("states/changeActiveID", newVal)
      }
    },
    componentTypes() {
      let moduleTypes = []
      if (this.request_prefix === "appStage") {
        moduleTypes = this.$store.state.appMenu.menu.moduleTypes || []
      } else if (this.request_prefix === "stage") {
        moduleTypes = this.$store.state.menu.menu.moduleTypes || []
      } else if (this.request_prefix === "bigScreen") {
        moduleTypes = this.$store.state.bigScreenMenu.menu.moduleTypes || []
      }
      console.log("moduleTypes",moduleTypes)
      let list = []
      //收藏的时候，需要只展示当前选中的组件的类型
      let elementType = this.$store.state.states.elementType
      moduleTypes.forEach(item => {
        if (item && item.componentType === elementType) {
          list.push({
            label: item.name,
            value: item.encId,
            subs: item.subs
          })
        }
      })
      this.systemComponentId = list[0]?.value
      //列表页的图文或者文本列表的id获取
      if(this.isListPage && elementType === "emptyLayoutComponent"){
        list = []
        let otherModuleTypes = [],
          listComponent = []
        if (this.request_prefix === "appStage") {
          otherModuleTypes = this.$store.state.appMenu.menu.otherTypes || []
        } else if (this.request_prefix === "stage") {
          otherModuleTypes = this.$store.state.menu.menu.otherTypes || []
        } else if (this.request_prefix === "bigScreen") {
          otherModuleTypes = this.$store.state.bigScreenMenu.menu.otherTypes || []
        }
        if (otherModuleTypes.length > 0) {
          listComponent = otherModuleTypes.find(item => item.name === "后台分类列表组件").subs
        }
        let elementName = this.$store.state.states.getDataPageIds.name
        // 兼容线上图文列表收藏失败问题：getDataPageIds的name与选中组件名称不一致导致
        if(this.getOptions.menuName){
          elementName = this.getOptions.menuName
        }
        listComponent.forEach(item => {
          if (item && elementName.includes(item.name)) {
            list.push({
              label: item.name,
              value: item.encId,
              subs: item.subs
            })
          }
        })
      }
      return list
    },
    containerClass() {
      return function (container, index) {
        if (!container.options) {
          return {}
        }
        if (!container.options.containerAnimateSet || !this.isPhoneFullScreen || this.isEditMode) {
          return {
            active: container.isActive,
            fixed: container.options.hasOwnProperty("isFixed") && container.options.isFixed ? true : false
          }
        }

        // let animateClass =
        //   this.animateOrder === "prev"
        //     ? container.options.containerAnimateSet.animateClass__pageUp
        //     : container.options.containerAnimateSet.animateClass__pageDown
        // let nextAnimateClass = container.options.containerAnimateSet.nextAnimateClass
        // let prevAnimateClass = container.options.containerAnimateSet.prevAnimateClass
        // let newStageClass = this.animateOrder === "prev" ? nextAnimateClass : prevAnimateClass
        // let animateType = container.options.containerAnimateSet.animateType
        // return [
        //   container.isActive ? "active" : "",
        //   container.options.hasOwnProperty("isFixed") && container.options.isFixed ? "fixed" : "",
        //   this.autoPlayAnimate && this.showStageIndex === index ? animateClass : "",
        //   this.autoPlayAnimate && this.showStageIndex === index ? "animate-active" : "",
        //   this.autoPlayAnimate && this.showStageIndex === index ? `cx-animate-${animateType}` : "",
        //   this.autoPlayAnimate && this.oldStageIndex === index ? newStageClass : "",
        //   this.showStageIndex === index && !this.autoPlayAnimate ? "animate-current" : "",
        //   this.autoPlayAnimate && this.oldStageIndex === index ? "animate-current" : ""
        // ]
      }
    },
    containerAnimateTime() {
      let time = []
      this.dataSource.children.forEach((container, index) => {
        let thisTime =
          container.options.containerAnimateSet && container.options.containerAnimateSet.autoPlayTime
            ? container.options.containerAnimateSet.autoPlayTime
            : 3
        time.push(thisTime)
      })
      return time
    },
    getOptions: function () {
      let rect = this.getAttrById(this.$store.state[this.request_prefix], this.ids)
      return rect?.options ? rect?.options : rect
    },
    animateRects() {
      let rects = []
      this.dataSource.children.forEach(stage => {
        stage.children.forEach(rect => {
          if (rect.options.pageloadAnimates && rect.options.pageloadAnimates.length > 0) {
            let ids = { container_id: stage.container_id, rect_id: rect.rect_id }
            let pageLoadAnimateClass = this.getPageLoadAnimateClass(rect.options, ids)
            rects.push({
              ids: ids,
              pageloadAnimates: rect.options.pageloadAnimates,
              pageLoadAnimateClass: pageLoadAnimateClass
            })
          }
        })
      })
      return rects
    },
    isClonePattern() {
      return this.$store.state.states.isClonePattern
    },
    isOrderPattern() {
      return this.$store.state.states.isOrderPattern
    },
    subPagePreview() {
      if (Object.keys(this.$store.state.states.getDataPageIds || {}).length === 0) {
        return true
      }
      return !!this.$store.state.states.getDataPageIds.pv
    },
    showEditShape() {
      return this.$store.state.states.showEditShape || false
    },
    inWaterGrid() {
      const rect = getAttrById(this.$store.state[this.request_prefix], this.ids, "rect")
      const length = Object.keys(this.ids)?.length
      if ((length === 2 || length === 3) && rect && rect.i && this.baseComponent.indexOf(rect.shape) === -1) {
        // 栅格下的复杂组件不允许复制
        return true
      }
      return false
    },
    showSmartServices: {
      get() {
        const showSmartServices = this.$store.state[this.request_prefix].page.showSmartServices
        return showSmartServices || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "showSmartServices", option_val: newVal })
      }
    },
    getRobotClass() {
      const pageLayoutId = this.pageLayoutList.findIndex(layout => layout.options.smartServices)
      return [this.ids.pageLayoutId == pageLayoutId ? "select-active" : ""]
    },
    robotCover() {
      const pageLayout = this.pageLayoutList.find(layout => layout.options.smartServices)
      let robotList = sessionStorage.getItem("robotList")
      robotList = robotList ? JSON.parse(robotList) : []
      let encode = robotList[0]?.encode
      if (!pageLayout?.options.robotEncode && this.ids.hasOwnProperty("pageLayoutId")) {
        this.$changeOptionsEV(encode, "robotEncode", false)
      }
      return pageLayout?.options?.robotCover || robotList[0]?.buttonImg
    },
    isListPage() {
      let stage = this.$store.state[this.request_prefix],
        isListPage = false
      if (stage.type === "listPage") {
        isListPage = true
      }
      return isListPage
    }
  },
  // 中间画布区域滚动时，动态设置左右两边折叠箭头的位置
  methods: {
    smartClick() {
      // 模拟机器人通栏点击
      this.showRightToolbar = true
      const pageLayoutId = this.pageLayoutList.findIndex(layout => layout.options.smartServices)
      this.$store.commit("states/changeActiveID", { container_id: 0, pageLayoutId: pageLayoutId })
      this.$store.commit("states/changeElementType", "cxPageLayout")
    },
    resetContentWidth() {
      this.contentWidth = document.getElementById("vueRulerContainer").getBoundingClientRect().width
      this.adaptEditPage()
    },
    saveWebjson() {
      this.$refs.topOperation.save()
    },
    judgeShowRightToolbar() {
      let rectId = this.ids.rect_id
      let pageLayoutId = this.ids.pageLayoutId
      if (
        !this.showAllScreen &&
        ((rectId !== null && typeof rectId !== "undefined") ||
          (pageLayoutId !== null && typeof pageLayoutId !== "undefined"))
      ) {
        this.$store.commit("states/changeShowRightToolbarStatus", true)
      }
    },
    judgeSyncData() {
      if (this.request_prefix !== "appStage") {
        return
      }
      let stage = this.$store.state.appStage
      // 单纯的移动端 不需要同步数据

      if (stage.page.hasOwnProperty("isPcSyncApp") && stage.page.isPcSyncApp) {
        // 已经同步过（包括手动同步），边部自动同步
        return
      }

      if ((stage.type === "listPage" || stage.type === "detailPage") && stage) {
        // 说明是子页面的移动端
        return
      }

      let createTime = sessionStorage.getItem("createTime")
      sessionStorage?.removeItem("createTime")
      if (!createTime) {
        return
      }
      createTime = createTime?.split(" ")
      let createTime1 = createTime[0].split("-")
      let createTime2 = createTime[1].split(":")
      let createTimeArr = createTime1.concat(createTime2)
      let nowDate = [2022, 12, 27]
      let pageIsNew = false
      // -2 是省掉分和秒
      for (let j = 0; j < nowDate.length; j++) {
        if (createTimeArr[j] > nowDate[j]) {
          pageIsNew = true
          break
        }
      }
      // 2022-12-28 之前的模版不处理
      if (!pageIsNew) {
        return
      }
      this.syncBtnData()
    },
    getPrimaryStage(container) {
      if (container?.options) {
        return container.options
      } else {
        const mock = { primaryappStageGenerator, primarybigScreenGenerator, primarystageGenerator }
        if (new mock["primary" + this.request_prefix + "Generator"]().options.con) {
        }
        let mockData = new mock["primary" + this.request_prefix + "Generator"]().options
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "options",
          data: mockData,
          containerId: container.container_id
        })
        return mockData
      }
    },
    changeElemetnType(e) {
      this.$store.commit("states/changeElementType", "page")
    },
    rulerClick() {
      // 单击标尺组件时清除布局组件内的acitve
      this.handdleClearActive()
    },
    lineClick() {
      this.handdleClearActive()
    },
    editBgClick() {
      this.handdleClearActive()
    },
    handdleClearActive() {
      this.$store.dispatch(this.request_prefix + "/unsetActive", this.ids)
      this.$store.commit("states/changeActiveID", null)
      this.$store.commit("states/changeElementType", null)
      this.$store.commit("states/changeToolBarStatus", false)
      this.$store.commit("states/changeAlignHelperStatus", false)
    },
    formatTooltip(val) {
      return parseInt(val * 100) + "%"
    },
    zoomCanvas: _throttle(function () {
      if (this.loaded) {
        setTimeout(() => {
          this.$refs.content_p_w.windowResize()
        })
      }
    }, 10),
    foldMenu() {
      this.showLeftMenus = !this.showLeftMenus

      // 左侧菜单的收起展开会影响左侧抽屉弹窗的位置
      if (!this.showLeftMenus) {
        // 找到class=customDrawer的class=el-drawer__wrapper的父元素
        $(".customDrawer").closest(".el-drawer__wrapper").css("left", "30px")
        $(".cutome-drawer-modal").css("left", "30px")
      } else {
        $(".customDrawer").closest(".el-drawer__wrapper").css("left", `${this.leftMenuWidth}px`)
        $(".cutome-drawer-modal").css("left", `${this.leftMenuWidth}px`)
      }

      this.adaptAndResize()
    },
    // flag = true表示自动开发
    foldToolbar(flag) {
      if (this.isClonePattern || this.isOrderPattern) {
        return
      }
      if (!flag) {
        this.showRightToolbar = !this.showRightToolbar
      }

      if (!this.showRightToolbar) {
        $(".customDrawer").closest(".el-drawer__wrapper").css("right", "30px")
        $(".cutome-drawer-modal").css("right", "30px")
      } else {
        $(".customDrawer").closest(".el-drawer__wrapper").css("right", "260px")
        $(".cutome-drawer-modal").css("right", "260px")
      }

      this.adaptAndResize()
    },
    adaptAndResize() {
      let leftWidth = this.showLeftMenus ? `${this.leftMenuWidth}px` : "30px"
      let rightWidth = this.showRightToolbar ? "260px" : "30px"

      $(".customDrawer")
        .closest(".el-drawer__wrapper")
        .css("width", "calc(100% - " + leftWidth + " - " + rightWidth + ")")
      $(".customDrawer")
        .closest(".el-drawer__wrapper")
        .css("width", "calc(100% - " + leftWidth + " - " + rightWidth + ")")
      $(".cutome-drawer-modal").css("width", "calc(100% - " + leftWidth + " - " + rightWidth + ")")

      this.$nextTick(() => {
        this.contentWidth = document.getElementById("vueRulerContainer").getBoundingClientRect().width
        setTimeout(() => {
          if (!this.showAllScreen && this.request_prefix === "stage") {
            // 全屏模式不进行缩放
            return
          }
          this.adaptEditPage()
          this.$refs.content_p_w.windowResize()
        }, 100)
      })
    },
    zoomEditPage(val) {
      let STEP = 0.05
      if (this.request_prefix === "bigScreen") {
        STEP = 0.01
      }
      if (val === "zoomIn") {
        this.zoom = this.zoom + STEP > this.maxZoom ? this.maxZoom : this.zoom + STEP
      } else if (val === "zoomOut") {
        this.zoom = this.zoom - STEP < this.minZoom ? this.minZoom : this.zoom - STEP
      }
    },
    // 适应画布，将画布以最大的尺寸完全呈现在编辑区域
    adaptEditPage(adaptFlag) {
      let editArea = this.$refs.editPage.getBoundingClientRect()
      let editAreaW = editArea.width
      let editAreaH = editArea.height
      if (this.showRuler || this.request_prefix === "bigScreen") {
        editAreaW -= 24
        editAreaH -= 24
      }
      if (this.request_prefix === "bigScreen") {
        let sizeProportion1 = this.dataSource.children[0].width / this.dataSource.children[0].height
        let sizeProportion2 = editAreaW / editAreaH
        let zoom =
          sizeProportion1 > sizeProportion2
            ? editAreaW / this.dataSource.children[0].width
            : editAreaH / this.dataSource.children[0].height
        this.zoom = Math.floor(zoom * 100) / 100
      } else if (this.request_prefix === "stage" && this.showAllScreen) {
        if (this.showLeftMenus && adaptFlag) {
          editAreaW -= this.leftMenuWidth
        }
        if (this.showRightToolbar && adaptFlag) {
          editAreaW -= this.rightToolbarWidth
        }
        let zoom = editAreaW / this.basePageWidth
        this.zoom = zoom
      } else {
        // 移动端
        this.zoom = 1
      }
    },
    // 改变画布的大小
    changeContainerSize(pageSize) {
      let width = Number(pageSize[0]),
        height = Number(pageSize[1])
      this.$store.dispatch("bigScreen/changeContainerAttribute", {
        key: "width",
        data: width,
        containerId: 0
      })
      this.$store.dispatch("bigScreen/changeContainerAttribute", {
        key: "height",
        data: height,
        containerId: 0
      })
    },
    clickHandle(e) {
      let _x = e.clientX,
        _y = e.clientY
      this.mouseX = _x + "px"
      this.mouseY = _y + "px"
    },
    // 键盘事件
    isKeyPressed() {
      let _this = this
      document.addEventListener("keydown", this.keyPressEvent)
      document.addEventListener("wheel", this.wheelEvent, { passive: false })
      document.onclick = function () {
        _this.showRightBtn = false
      }
      document.addEventListener("keyup", ()=>{
        _this.zoomScrolling = false
        _this.ctrlDown = false
        _this.shiftDown = false
        localStorage.removeItem("multipleComponent")
        if (_this.updatePosition) {
          document
              .getElementById("editPage")
              .getElementsByClassName("el-scrollbar__wrap")[0]
              .classList.remove("overHidden")
          _this.updatePosition = false
        }
      })
      // document.onkeyup = function (e) {
      //   alert(222)
      //   _this.zoomScrolling = false
      //   _this.ctrlDown = false
      //   _this.shiftDown = false
      //   localStorage.removeItem("multipleComponent")
      //   if (_this.updatePosition) {
      //     document
      //       .getElementById("editPage")
      //       .getElementsByClassName("el-scrollbar__wrap")[0]
      //       .classList.remove("overHidden")
      //     _this.updatePosition = false
      //   }
      // }
    },
    keyPressEvent(e) {
      let _this = this
      // 克隆和排序状态下不进行快捷键操作
      if (_this.isClonePattern || _this.isOrderPattern) {
        return
      }
      let key = window.event.keyCode
      // enter之后 输入框失焦 然后将当前value存到options中
      if (key === 13) {
        let inp = document.getElementsByClassName("el-input__inner")
        for (let i = 0; i < inp.length; i++) {
          inp[i].blur()
        }
      }
      if (!_this.isInStage) {
        if (!this.activeComponent) {
          return
        }
      }
      //shift键
      if (key == 16) {
        if (!_this.shiftDown && _this.ids.hasOwnProperty("rect_id") && _this.ids.rect_id !== null) {
          sessionStorage.setItem("tmpComponents", JSON.stringify([_this.ids]))
        }
        localStorage.setItem("multipleComponent", true)
        _this.shiftDown = true
      }
      if (window.event.ctrlKey || window.event.metaKey) {
        _this.ctrlDown = true
      }
      // ctrl+c 复制
      if (_this.ctrlDown && key === 67) {
        // 如果复制的是右侧工具栏的元素，不需要记录
        const toolbarDom = document.getElementsByClassName("right-toolbar")[0]
        if (toolbarDom && toolbarDom.contains(e.target)) {
          return
        }
        if(!this.showComponentCopy){
          return
        }
        _this.copyComponent()
      }
      // ctrl+v 粘贴
      if (_this.ctrlDown && key === 86) {
        _this.pasteComponent("ctrlv")
      }
      // delete/backspace 删除
      if (key === 46) {
        if (!sessionStorage.getItem("isDeletingConfirm")) {
          let delComponents = JSON.parse(sessionStorage.getItem("tmpComponents"))
          _this.del(delComponents)
          sessionStorage.removeItem("tmpComponents")
        }
      }
      // ctrl+g 编组  布局模式下屏蔽编组
      if (_this.ctrlDown && key === 71 && _this.shiftDown === false && !this.isLayout) {
        _this.inGroup()
      }
      // ctrl + shift + g 取消编组
      if (_this.ctrlDown && key === 71 && _this.shiftDown === true) {
        _this.cancleGroup()
      }
      // ctrl+z 撤销
      if (_this.ctrlDown && !_this.shiftDown && key === 90) {
        if (_this.request_prefix !== "bigScreen") {
          _this.$refs.topOperation.goBackHandel()
        } else {
          _this.$refs.bigScreenTopOperation.goBackHandel()
        }
      }
      // ctrl + shift + z 重做
      if (_this.ctrlDown && _this.shiftDown && key === 90) {
        if (_this.request_prefix !== "bigScreen") {
          _this.$refs.topOperation.goNextHandel()
        } else {
          _this.$refs.bigScreenTopOperation.goNextHandel()
        }
      }
      // 大屏上下左右键控制移动
      if (_this.request_prefix === "bigScreen" && this.activeComponent) {
        let isEditStatu = sessionStorage.getItem("isEditStatu")
        let isInputFocus = sessionStorage.getItem("isInputFocus")
        let activeElement = document.activeElement
        if (activeElement && activeElement.tagName.toLowerCase() === "input") {
          // 当前是输入框正在进行操作
          return
        }
        // 文本编辑状态或者文本数据本地数据获取焦点状态 不进行键盘控制位置调整
        if (isEditStatu || isInputFocus) {
          return
        }
        let left = this.activeComponent.options.left
        let top = this.activeComponent.options.top
        if (this.ids.uid) {
          if (this.ids.elementInLayoutId === undefined) {
            /* 有uid就是选中单元格,单元格键盘不控制位置 */
            return
          } else {
            let rectAttr = this.getRectAttribute.call(this, this.ids)
            const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
            let pOptions = [rectAttr.options.rows[useActiveIndex]]
            let content = handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid).elementOptions[
              this.ids.elementInLayoutId
            ]
            left = content.left
            top = content.top
          }
        }
        // 左
        if (key === 37 && left > 0) {
          left = left - 1
          this.updatePosition = true
        }
        // 上
        if (key === 38 && top > 0) {
          top = top - 1
          this.updatePosition = true
        }
        // 右
        if (key === 39) {
          left = left + 1
          this.updatePosition = true
        }
        // 下
        if (key === 40) {
          top = top + 1
          this.updatePosition = true
        }
        if (this.updatePosition) {
          // 禁止滚动条滚动
          document
            .getElementById("editPage")
            .getElementsByClassName("el-scrollbar__wrap")[0]
            .classList.add("overHidden")
          this.$changeOptionsEV(top, "top", null, false, this.ids, true)
          this.$changeOptionsEV(left, "left", null, false, this.ids, true)
        }
      }
      //ctrl + + 放大
      if (_this.ctrlDown && key === 187) {
        this.zoomEditPage("zoomIn")
      }
      //ctrl + - 缩小
      if (_this.ctrlDown && key === 189) {
        this.zoomEditPage("zoomOut")
      }
      //ctrl + - 缩放至100%
      if (_this.shiftDown && key === 48) {
        this.zoom = 1
      }
    },
    wheelEvent(event) {
      let _this = this
      _this.zoomScrolling = false
      // 克隆和排序状态下不进行快捷键操作
      if (_this.isClonePattern || _this.isOrderPattern) {
        return
      }
      if (window.event.ctrlKey || window.event.metaKey) {
        event.preventDefault()
        // 判断滚轮向上还是向下
        if (event.deltaY < 0) {
          // 向上滚动，放大
          _this.zoomEditPage("zoomIn")
          _this.zoomScrolling = true
          if (!_this.showAllScreen) {
            _this.showAllScreen = true
          }
        } else if (event.deltaY > 0) {
          // 向下滚动，缩小
          _this.zoomEditPage("zoomOut")
          _this.zoomScrolling = true
          if (!_this.showAllScreen) {
            _this.showAllScreen = true
          }
        }
      }
    },
    vdrClickHandle() {
      this.isInStage = true
    },
    pageClick(event) {
      let stage = this.$refs.editPage
      if (stage && stage.contains(event.target)) {
        this.isInStage = true
      } else {
        this.isInStage = false
      }
      this.pageMouseX = event.clientX
      this.pageMouseY = event.clientY
    },
    getParentNodeByClassName(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if (elClasslist && [].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNodeByClassName(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    // 检查右键时的鼠标点是否落在了当前激活的通栏上
    checkLayoutContextMenu(e, type) {
      const res = []
      let cls = type === "cell" ? "layout-container" : "page-layout-wrapper"
      let activeClass = type === "cell" ? "set_active" : "select-active"
      this.getParentNodeByClassName(e.target, res, cls)
      if (!res.length) return false
      const vdrElement = res[0]
      // 解决激活自由布局悬浮到子组件上时无法右键展开菜单
      let res1 = []
      this.getParentNodeByClassName(vdrElement, res1, cls)
      const vdrParentElement = res1[0]
      if (vdrElement.className && vdrElement.className.includes(activeClass)) {
        return true
      } else if (vdrParentElement?.className && vdrParentElement?.className?.includes(activeClass)) {
        return true
      }
      return false
    },
    // 检查右键时的鼠标点是否落在了当前激活组件上
    checkContextMenu(e) {
      const res = []
      this.getParentNodeByClassName(e.target, res, "vdr")
      console.log("res", res)
      if (!res.length) return false
      const vdrElement = res[0]
      // 解决激活自由布局悬浮到子组件上时无法右键展开菜单
      let res1 = []
      this.getParentNodeByClassName(vdrElement, res1, "vdr")
      console.log("res1", res)
      const vdrParentElement = res1[0]
      if (vdrElement.className && vdrElement.className.includes("active")) {
        return true
      } else if (vdrParentElement?.className && vdrParentElement?.className?.includes("active")) {
        return true
      }
      return false
    },
    // 根据url的键名获取值
    getUrlParam(name) {
      var reg = new RegExp("[?&]" + name + "=([^&#]+)")
      var query = window.location.href.match(reg)
      return query ? query[1] : null
    },
   async judgeShowRectInfo(){
      this.curRectInfo = {}
     this.showRectInfo = false
      if(isExist(this.ids.rect_id) && !isExist(this.ids.uid) && !isExist(this.ids.cellId) && !isExist(this.ids.elementInSwiperId)){
        let tempOptions = getAttrById(this.$store.state[this.request_prefix], this.ids, "rect")?.options
        //行布局下的组件无法查看和修改appid
        if(isExist(this.ids.elementInAutoLayoutId)){
          tempOptions = getAttrById(this.$store.state[this.request_prefix], this.ids)
        }
        // appid为空时，也可以处理
        if(!tempOptions.appId){
          this.showRectInfo = true
          this.curRectInfo = {
            name: tempOptions.name || tempOptions.menuName,
            appId: '',
            createTime: ''
          }
        }
        if(!this.$store.state.states.showPluginSetting){
          //  未绑定插件，不开启
          this.showRectInfo = false
          return
        }
        let res = await this.$API.getComponentPermission({
          appId: tempOptions.appId
        })
        if(res.data.code !== 1 || !res.data.data){
          return
        }
        if(res.data.data.isSadmin){
          // 不是超管，不开启
          this.showRectInfo = true
          this.curRectInfo = {
            name: tempOptions.name || tempOptions.menuName,
            appId: tempOptions.appId,
            createTime: res.data.data.createTime
          }
        }
      }
    },
    contextmenuHandle(e) {
      console.log("contextmenuHandle", e)
      // 右键出弹框
      this.showLayoutSet = false
      this.showCellSet = false
      this.showColSet = false
      let copyComponents = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
      let stage = this.$store.state[this.request_prefix]
      this.judgeIsTabPageLayout()
      // 激活状态改变了 获取方式也要改变
      let isActive = false
      if (this.ids.elementInLayoutId !== null && typeof this.ids.elementInLayoutId !== "undefined") {
        if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
          let temp = getAttrById(stage, this.ids, "rect")
          if (temp.shape === "cxAutoLayout") {
            // 自由布局在自动布局中
            if ((this.ids.directionIndex !== null) & (typeof this.ids.directionIndex !== "undefined")) {
              isActive = getAttrById(stage, this.ids, "elementInTitleOptions")?.isActive
            } else {
              isActive = getAttrById(stage, this.ids, "autoLayout")?.isActive
            }
          } else {
            // 自动布局在自由布局中
            isActive = getAttrById(stage, this.ids, "elementInAutoLayout")?.active
          }
        } else if ((this.ids.directionIndex !== null) & (typeof this.ids.directionIndex !== "undefined")) {
          isActive = getAttrById(stage, this.ids, "elementInTitleOptions")?.isActive
        } else {
          isActive = getAttrById(stage, this.ids, "elementInLayout")?.isActive
        }
      } else if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
        isActive = getAttrById(stage, this.ids, "elementInAutoLayout")?.active
      } else if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        isActive = getAttrById(stage, this.ids, "elementInSwiper")?.isActive
      } else {
        const containerId = this.ids?.hasOwnProperty("container_id") ? this.ids.container_id : 0
        isActive = getAttrById(stage, {
          container_id: containerId,
          ...this.ids
        }, "rect")?.active
      }
      this.judgeShowRectInfo()
      if (isActive) {
        // 需要判断一次右键落到的位置是否是当前激活的组件内部
        if (this.request_prefix !== "bigScreen" && !this.checkContextMenu(e)) {
          isActive = false
        }
      }
      if (this.ids.pageLayoutId !== null && typeof this.ids.pageLayoutId !== "undefined") {
        // 通栏和布局右键
        let pageLayoutId = this.ids.pageLayoutId
        if (!isNaN(pageLayoutId) || pageLayoutId.length === 1) {
          let cell = this.getParentNodeByClassName(e.target, [], "layout-container")
          this.showLayoutSet = cell?.length > 0 ? false : this.checkLayoutContextMenu(e)
        } else {
          const pageLayout = getAttrById(this.$store.state[this.request_prefix], this.ids)
          const isTabShow = pageLayout?.options?.tabRow || pageLayout?.options?.tabCol // 标签布局
          this.showCellSet = this.checkLayoutContextMenu(e, "cell") && !isTabShow ? true : false
        }
      } else if (isExist(this.ids.uid) && !isExist(this.ids.elementInLayoutId) && this.request_prefix !== "bigScreen") {
        // 单元格
        let activeCol = this.getParentNodeByClassName(e.target, [], "col-box")
        let classList = activeCol[0]?.classList || []
        if (classList && classList.contains(this.ids.uid) && classList.contains("active-col")) {
          this.showColSet = true
        }
      }
      this.showCopy = this.ids.rect_id !== null && this.ids.rect_id !== undefined && isActive ? true : false
      this.showGroup =
        (!this.ids.uid || this.ids.uid === null) && this.ids.rect_id !== null && copyComponents.length > 1
          ? true
          : false
      this.showCancelGroup = this.judgeShowCancelGroup()
      this.showPaste = this.judgeShowPaste() && !this.showLayoutSet
      this.showLevel1 = this.showCopy && this.request_prefix === "bigScreen"
      this.showRightBtn = this.showCopy || this.showPaste || this.showLayoutSet || this.showCellSet || this.showColSet
      let _x = e.clientX,
        _y = e.clientY
      this.mouseX = _x + "px"
      this.mouseY = _y + "px"
      if (e.target.className === "icon handle-move") {
        // 右键鼠标放在栅格上
        // 栅格右键选中
        this.offsetX = e.offsetX
        this.offsetY = e.offsetY
        console.log("this.waterFallLayoutId :>>", this.waterFallLayoutId)
        const gridItem = this.getParentNodeByClassName(e.target, [], "grid-item-content")[0]
        const dataId = gridItem?.getAttribute("data-i")
        if (dataId && dataId !== this.activeGridId) {
          this.$store.dispatch(this.request_prefix + "/unsetActive", {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id
          })
          this.$store.commit("states/changeActiveID", {
            container_id: this.ids.container_id
          })
          this.$store.commit("states/changeElementType", null)
          this.activeGridId = dataId
        }
      } else if (this.isLayout && !!this.ids.pageLayoutId) {
        // 右键放到布局上
        this.offsetX = e.offsetX
        this.offsetY = e.offsetY
      } else if (this.activeGridId) {
        // 鼠标放在栅格内的组件上
        this.offsetX = e.layerX
        this.offsetY = e.layerY
      }
      if (this.showRightBtn) {
        this.$nextTick(() => {
          const rightMenuRect = document.querySelector(".rightMenuDialog").getBoundingClientRect()
          if (!rightMenuRect) return
          if (rightMenuRect.bottom > window.innerHeight) {
            // 说明已经超出屏幕了，还原一下位置
            this.mouseY = window.innerHeight - rightMenuRect.height + "px"
          }
        })
      }
    },
    //判断是否显示取消成组按钮
    judgeShowCancelGroup() {
      if (this.ids.container_id === null || this.ids.rect_id === null) {
        return false
      }
      let options = this.$getOptions({
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      })
      if (options.hasOwnProperty("disableSetColAndRow") && !options.disableCancleGroup) {
        return true
      }
    },
    // 判断是否显示粘贴按钮
    judgeShowPaste() {
      let stage = this.$store.state[this.request_prefix]
      if (this.copyCompontsData.length === 0) {
        return false
      }
      if (this.getOptions?.innerElement === "cxAutoLayout") {
        return true
      }
      if (isExist(this.ids.uid) && !isExist(this.ids.elementInLayoutId)) {
        // 选择为布局组件里面的空容器
        return true
      }
      if (
        this.ids.swiperContent_id !== null &&
        this.ids.swiperContent_id !== undefined &&
        (this.ids.elementInSwiperId === null || this.ids.elementInSwiperId === undefined)
      ) {
        // 选择为轮播组件里面的容器
        return true
      }
      if (this.ids.rect_id === null && !this.copyCompontsData[0].hasOwnProperty("options")) {
        return false
      }
      if (
        (isExist(this.ids.directionIndexOther) || isExist(this.ids.directionIndex)) &&
        this.copyCompontsData[0].hasOwnProperty("options")
      ) {
        return true
      }
      if (!isExist(this.ids.rect_id)) {
        return true
      } else if (!getAttrById(stage, this.ids, "rect").active) {
        return true
      }
      return true
    },
    // 复制组件
    copyComponent() {
      if (this.ids.rect_id === null || typeof this.ids.rect_id === "undefined" || this.hideCopy) {
        return
      }
      let _this = this,
        inCol
      let copyComponents = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
      if (copyComponents.length === 0 && this.ids.rect_id !== null) {
        //单选
        sessionStorage.setItem("tmpComponents", JSON.stringify([this.ids]))
        copyComponents.push({
          ...this.ids
        })
      }
      inCol = copyComponents[0].uid ? true : false
      this.copyCompontsData = []
      this.showRightBtn = false
      let stage = _this.$store.state[_this.request_prefix]
      sessionStorage.setItem("tmpComponents", "[]")
      if (!inCol) {
        if (
          (this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined") ||
          (this.ids.directionIndexOther !== null && typeof this.ids.directionIndexOther !== "undefined")
        ) {
          // 自由布局四种的基础组件  不能复制，因为数据关联太多 比如分页 tab
          //选中的为布局四边栏里面的某个组件
          let index =
            this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined"
              ? this.ids.directionIndex
              : this.ids.directionIndexOther !== null && typeof this.ids.directionIndexOther !== "undefined"
              ? this.ids.directionIndexOther
              : ""
          let titleOptions = getAttrById(stage, _this.ids, "rect").options.titleOptions
          if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
            titleOptions = getAttrById(stage, _this.ids, "elementInAutoLayout")?.titleOptions
          }
          if (titleOptions)
            titleOptions[index].elementOptions.forEach(data => {
              if (data.isActive) {
                if (data.innerElement === "cxTabs" || data.innerElement === "cxPagination" || data.type === "more") {
                  this.$message({
                    customClass: "bigScreen_msg_backGroud",
                    duration: 3000,
                    message: "系统组件不支持复制，请转到右侧栏>设置，通过开关开启组件",
                    type: "warning"
                  })
                  return
                }
                // 关闭复制组件的激活状态
                let tmpData = simpleDeepClone(data)
                tmpData.rect_id = _this.ids.rect_id
                _this.copyCompontsData.push(tmpData)
                // data.isActive = false
              }
            })
        } else if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
          // 选中轮播内的组件
          let options = getAttrById(stage, _this.ids, "rect").options
          if (options && options.content && options.content.length > 0) {
            options.content.forEach(item => {
              if (item.swiperContent_id === _this.ids.swiperContent_id) {
                item.elementOptions?.forEach(data => {
                  if (data.isActive) {
                    // 关闭复制组件的激活状态
                    let tmpData = simpleDeepClone(data)
                    tmpData.rect_id = _this.ids.rect_id
                    _this.copyCompontsData.push(tmpData)
                    // data.isActive = false
                  }
                })
              }
            })
          }
        } else if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
          let data = getAttrById(stage, _this.ids, "elementInAutoLayout")
          let tmpData = simpleDeepClone(data)
          if(_this.ids.cellId && isExist(_this.ids.elementInDataGridId)) {
            tmpData = data.cells.find(cell=>cell.cellId === _this.ids.cellId)
            tmpData = tmpData.elementOptions.find(element=>element.elementInDataGridId === _this.ids.elementInDataGridId)
          }
          _this.copyCompontsData.push(tmpData)
        } else if (this.ids.cellId  && isExist(this.ids.elementInDataGridId)) {
          let dataDrid = getAttrById(stage, _this.ids)
          let tmpDataGrid = simpleDeepClone(dataDrid)
          // if(_this.ids.cellId && isExist(_this.ids.elementInDataGridId)) {
          //   tmpData = data.cells.find(cell=>cell.cellId === _this.ids.cellId)
          //   tmpData = tmpData.elementOptions.find(element=>element.elementInDataGridId === _this.ids.elementInDataGridId)
          // }
          _this.copyCompontsData.push(tmpDataGrid)
        } else {
          //选中画布中的普通组件
          copyComponents.forEach(ids => {
            let hasExist = false
            for (let i = 0; i < _this.copyCompontsData.length; i++) {
              let target = _this.copyCompontsData[i]
              if (ids.rect_id == target.rect_id) {
                hasExist = true
                break
              }
            }
            if (!hasExist) {
              let tmpData = getAttrById(stage, ids, "rect")
              _this.copyCompontsData.push(tmpData)
            }
          })
        }
      } else {
        let nodes
        if (this.ids.elementInLayoutId !== null && typeof this.ids.elementInLayoutId !== "undefined") {
          //选中的为布局里面的某个组件
          let tempRect = getAttrById(stage, _this.ids, "rect").options
          if (tempRect.innerElement === "cxAutoLayout" && _this.ids.elementInAutoLayoutId !== "undefined") {
            // 自由布局在自动布局中
            tempRect = getAttrById(
              stage,
              {
                ..._this.ids,
                elementInLayoutId: null
              },
              "elementInAutoLayout"
            )
          }
          const useActiveIndex = tempRect.categoryMode === CATEGORY_MODE.SAME ? 0 : tempRect.activeIndex
          nodes = tempRect.rows[useActiveIndex]
          let findResult = _this.findPathByLeafId(_this.ids.uid, nodes)
          if (
            this.ids.elementInAutoLayoutId !== null &&
            typeof this.ids.elementInAutoLayoutId !== "undefined" &&
            !tempRect.hasOwnProperty("elementInAutoLayoutId")
          ) {
            // 自动布局在自由布局中
            // 查找当前选中元素所在的自动布局
            findResult = findResult?.elementOptions?.find(
              data => data.elementInLayoutId === _this.ids.elementInLayoutId
            )
          }
          if (findResult)
            findResult.elementOptions.forEach(data => {
              if (data.isActive || data.active) {
                // 关闭复制组件的激活状态
                let tmpData = simpleDeepClone(data)
                tmpData.rect_id = _this.ids.rect_id
                _this.copyCompontsData.push(tmpData)
                // data.isActive = false
              }
            })
        } else {
          // 复制整个布局组件
          nodes = simpleDeepClone(getAttrById(stage, _this.ids, "rect"))
          deepChangeUid(nodes)
          _this.copyCompontsData.push(nodes)
        }
      }
      return copyComponents
    },
    // 收藏组件(和2.0保存样式一样，大屏这边换一种说法)
    collect() {
      this.dialogFormVisible = true
    },
    setMobileSystemStyleToPc() {
      if (isNaN(this.ids.rect_id) === false) {
        console.log({
          ids: { ...this.ids },
          height: document.getElementsByClassName(
            `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`
          )[0].offsetHeight
        })
        sessionStorage.setItem(
          "mobileSystemStyleToPc",
          JSON.stringify({
            ids: { ...this.ids },
            height: document.getElementsByClassName(
              `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`
            )[0].offsetHeight
          })
        )
      }
      this.showRightBtn = false
    },
    // 设为系统样式
    setSystemStyle(flag) {
      if (this.showLayoutSet) {
        this.pageLayoutClick(flag)
        return
      }
      //收藏交互修改后，目前仅限首页，列表页详情页保持原有逻辑
      //统一子页面组件的收藏交互：编辑页收藏交互修改为与首页同步
      if (flag && this.collectNewVersion) {
        this.dialogFormVisible2Title = "样式名称"
        this.collectStatusNew = true
      } else {
        this.dialogFormVisible2Title = "组件样式上传"
        this.collectStatusNew = false
      }
      let opt = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      opt = opt.options ? opt.options : opt
      const drawer = $(".cutome-drawer-modal")
      const popover = $(".el-popover__open")
      if ((drawer && drawer.length > 0) || popover && popover.length > 0) {
        // 为了解决：抽屉弹窗开启中会挡住dialogFormVisible2弹窗
        this.dialogFormVisible2AppendToBody = true
      }else{
        this.dialogFormVisible2AppendToBody = false
      }
      this.dialogFormVisible2 = true
      this.isCollect = flag

      if (opt && (opt.name || opt.menuName)) {
        this.systemModuleForm.name = opt.name || opt.menuName
      } else {
        this.systemModuleForm.name = null
      }
      this.systemComponentType = null
      this.systemComponentCover = ""
      if (this.componentTypes.length > 0 && opt && opt.menuName) {
        for (let i = 0; i < this.componentTypes.length; i++) {
          if (this.componentTypes[i].label === opt.menuName) {
            this.systemComponentId = this.componentTypes[i]?.value
          } else if (this.isListPage && opt.menuName.includes(this.componentTypes[i].label)) {
            this.systemComponentId = this.componentTypes[i]?.value
          }
        }
      } else {
        this.systemComponentId = this.componentTypes[0]?.value
      }
      if (this.systemComponentId) {
        this.changeComponentType(this.systemComponentId)
      }
      // 首页收藏 获取自动截图的封面
      if (this.isCollect && this.collectNewVersion) {
        if (this.systemComponentId && this.subComponentTypes.length >= 1) {
          setTimeout(() => {
            this.takeScreenshot()
          }, 300)
        } else {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error",
            message: "暂不支持收藏"
          })
          this.dialogFormVisible2 = false
          this.showRightBtn = false
        }
      }
    },
    // 自动截图作为收藏封面
    takeScreenshot() {
      let collectComponent = document.getElementsByClassName(
        `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`
      )[0]
      let collectComponentIn = collectComponent.getElementsByClassName("rect")[0]
      let opt1 = {
        scale: 1,
        width: collectComponentIn.clientWidth,
        height: collectComponentIn.clientHeight,
        useCROS: true
      }
      this.screenShotting = true
      html2canvas(collectComponentIn, opt1)
        .then(canvas => {
          let base64 = canvas.toDataURL("image/png")
          this.screenShotImgUpload(base64)
        })
        .catch(error => {
          this.screenShotting = false
          // 截图过程中出现错误
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error",
            message: "获取收藏封面失败"
          })
        })
    },
    // 收藏封面自动截图图片上传
    screenShotImgUpload(base64) {
      this.instance({
        method: "post",
        url: `usts/base64`,
        headers: { "Content-Type": "application/json;charset=utf-8" },
        data: base64
      }).then(res => {
        if (res.data.code === 1) {
          this.systemComponentCover = res.data.data.url
          this.screenShotting = false
        }
      })
    },
    isAnchor() {
      // 锚点组件 不允许删除组件
      // 查找当前通栏的路径
      const path = findCurrentComponentPathInLayoutByRectId(this.pageLayoutList, this.ids.rect_id).join("_")
      let pageLayout = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        {
          container_id: this.ids.container_id,
          pageLayoutId: path[0]
        },
        "pageLayout"
      )
      let inDocument = pageLayout?.options?.inDocument
      if (inDocument && ["anchor"].indexOf(inDocument) > -1) {
        return true
      }
      return false
    },
    judgePageLayoutCanDelOrCopy(){
      // todo 待通栏的类型标识统一后，一起做优化
      if (isExist(this.ids.pageLayoutId) && !isExist(this.ids.rect_id)){
        let layoutIdArr = this.ids.pageLayoutId.toString().split("_")
        if(layoutIdArr.length > 1){ // 说明当前不是通栏
          return true
        }
        const layout = getAttrById(this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id || 0,
          pageLayoutId: this.ids.pageLayoutId
        })
        const index = Number(this.ids.pageLayoutId)
        if ((index === 0 && layout.options.inDocument === "header") || layout.options.inDocument === "relativeHeader") {
          return false
        }
        if (index === this.pageLayoutList.length - 1 && layout.options.inDocument === "footer") {
          return false
        }
        if (layout.options.inDocument === "anchor") {
          return false
        }
        return true
      } else return true
    },
    judgeIsTabPageLayout() {
      // 布局标签不允许添加行列
      this.isTabPageLayout = false
      this.isBayWindow = false
      this.isAccordionLayout = false
      this.openIndex = -1
      if (this.ids.pageLayoutId) {
        if (isExist(this.ids.rect_id)) {
          // 标签布局组件，结构固定，不允许添加列
          this.isTabPageLayout = true
        }
        // 旧版的带标签的布局，不允许添加列
        let pageLayoutId = []
        if (typeof this.ids.pageLayoutId === "number") {
          // this.ids.pageLayoutId = (this.ids.pageLayoutId + "").split("_")
          pageLayoutId = (this.ids.pageLayoutId + "").split("_")
        } else {
          pageLayoutId = this.ids.pageLayoutId.split("_")
        }

        if (pageLayoutId.length > 0) {
          pageLayoutId = pageLayoutId.splice(0, 1).join("_")
          const pageLayoutOption = getAttrById(this.$store.state[this.request_prefix], {
            ...this.ids,
            pageLayoutId: pageLayoutId
          })
          if (pageLayoutOption.options.enableBayWindow) {
            this.isBayWindow = true
          }
          if (pageLayoutOption.options.isShowTabs) {
            this.isTabPageLayout = true
          }
          if (pageLayoutOption.options.isAccordionLayout) {
            this.isAccordionLayout = true
            this.openIndex = pageLayoutOption.options.openIndex
          }
        }
      }else if(this.$store.state.states.elementType === "cxTabs"){
        const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")
        if(rectAttr && rectAttr.options && (isExist(rectAttr.options.parentRectId) || rectAttr.options.isPageLayoutTabs)){
          // 栅格下标签布局下的tab
          this.isTabPageLayout = true
        }
      }
    },
    //删除事件触发
    del(ids) {
      // 按钮，文本的编辑状态下不能删除
      if (sessionStorage.getItem("isBtnEditStatu") || sessionStorage.getItem("isEditStatu")) {
        return
      }
      // 布局标签不允许快捷删除布局
      this.judgeIsTabPageLayout()
      if (this.isTabPageLayout) {
        return
      }
      if (this.showLayoutSet || this.showCellSet) {
        this.pageLayoutClick(5)
        return
      }
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      // 子页面预设组件
      if (rectAttr && rectAttr.preComponent) return
      // 登录框的标签组件不允许删除
      if (this.getOptions && (this.getOptions.innerElement === "cxTabs" || (this.getOptions.innerElement === 'cxSelect' && this.getOptions.quoteTo === "cxTabs"))) {
        let emptyLayoutComponent = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          path: this.ids.path,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId
        })
        emptyLayoutComponent = emptyLayoutComponent?.options ? emptyLayoutComponent.options : emptyLayoutComponent
        if (
          emptyLayoutComponent &&
          emptyLayoutComponent.pluginName &&
          emptyLayoutComponent.pluginName.includes("loginEngineComponentPlugin")
        ) {
          return
        }
      }
      // searchType 搜索内部指定组件 不允许删除 loginType 登录框内部组件
      if (
        this.ids.rect_id === null ||
        this.ids.rect_id === undefined ||
        this.ids.hasOwnProperty("pageLayoutId") ||
        this.isAnchor() ||
        this.getOptions?.searchType ||
        this.getOptions?.loginType ||
        this.getOptions?.noticeInnerComp
      ) {
        // 通栏的删除在pageLayout中
        return
      }
      if(rectAttr?.options?.pluginName?.includes("goTopPlugin") ||
      rectAttr?.options?.pluginName?.includes("controlPopoverPlugin")) {
        return
      }
      let thisIds = Array.isArray(ids) && ids.length > 0 ? ids : this.ids

      if (thisIds.elementInLayoutId === null) {
        thisIds.uid = null
      }
      this.$store.commit("states/changeToolBarStatus", false)
      // 当前为单元格的最上一层，不执行删除操作
      if (
        this.ids.uid &&
        !isExist(this.ids.elementInLayoutId) &&
        $(`#componentBox_after${this.ids.uid}`).parents(".row").length === 1
      ) {
        return
      }
      this.delElementEv(thisIds)
    },
    //删除element
    delElementEv(args) {
      sessionStorage.setItem("isDeletingConfirm", true)
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          sessionStorage.removeItem("isDeletingConfirm")
          //执行删除操作
          //获取所有键
          if (Array.isArray(args)) {
            args.forEach(item => {
              console.log({ ...this.ids, ...item })
              let isDelRect = this.updateWaterFallGrid({ ...this.ids, ...item })
              !isDelRect && this.$store.dispatch(this.request_prefix + "/deleteElement", { ...this.ids, ...item }) // 通知列表更新数据
            })
          } else {
            let isDelRect = this.updateWaterFallGrid(args)
            if (!isDelRect) {
              this.$addHistory({
                type: "delete",
                stateType: "deleteElement",
                payload: { ...this.ids }
              })
              this.$store.dispatch(this.request_prefix + "/deleteElement", args)
            }
          }
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {
          sessionStorage.removeItem("isDeletingConfirm")
        })
    },
    updateWaterFallGrid(ids) {
      if (this.$store.state[this.request_prefix].page.isWaterFall !== "waterFall") {
        return
      }
      let newIds = idsFilter(ids)
      let isDelRect = false
      if (objectSize(newIds) === 2 && newIds.hasOwnProperty("container_id") && newIds.hasOwnProperty("rect_id")) {
        isDelRect = true
      } else if (
        objectSize(newIds) === 3 &&
        newIds.hasOwnProperty("directionIndexOther") &&
        newIds.hasOwnProperty("container_id") &&
        newIds.hasOwnProperty("rect_id")
      ) {
        isDelRect = true
      } else if (
        objectSize(newIds) === 3 &&
        newIds.hasOwnProperty("swiperContent_id") &&
        newIds.hasOwnProperty("container_id") &&
        newIds.hasOwnProperty("rect_id")
      ) {
        isDelRect = true
      }
      if (isDelRect) {
        const [ parentRectId ] = findPathInComponentLayoutByRectId(newIds)
        isDelRect = parentRectId ? false : isDelRect
      }
      if (isDelRect) {
        let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: newIds.container_id,
          rect_id: newIds.rect_id
        })
        sessionStorage.setItem("delWaterFallGrid", true)
        this.$eventBus.$emit(`del-waterFall-grid`, {
          gridId: rectAttr.i,
          shape: rectAttr.shape,
          ids: {
            ...newIds
          }
        })
        return this.baseComponent.indexOf(rectAttr.shape) === -1 ? true : false
      }

      return isDelRect
    },
    getContent(ids, height, encType, env) {
      console.log("ids :>>", ids)
      // 判断收藏时是否是收藏整个轮播 去掉swiperContent_id
      if (isExist(ids.swiperContent_id) && !isExist(ids.elementInSwiperId)) {
        delete ids.swiperContent_id
      }
      // 新增任何地方的按钮都可以收藏，所以获取属性的方式发生改变
      let rect = simpleDeepClone(this.getAttrById(this.$store.state[env || this.request_prefix], ids))
      let content = rect.options
        ? rect
        : {
            options: rect
          }
      //自由布局内的组件支持单独收藏，需要添加默认设置
      // 自动布局、轮播等复杂组件内部的组件也要支持收藏
      if (ids.uid || !content.shape) {
        content.shape = content.options.innerElement
        content.draggable = true
        content.resizable = true
        content.parentLim = true
        content.hoverZIndex = 1
        content.color = "rgba(239,154,154,1)"
      }
      // delAnimateGroup(content.options)
      // 删除不在该组件内的动画
      delAnimateOutCurrentRect(
        this.$store.state[this.request_prefix],
        {
          ...this.ids
        },
        content
      )
      // 业务组件收藏时，需要删除特殊属性
      if (content.shape === "cxButton") {
        delete content.options.loginType
      }
      // 分享组件高度自适应 不能修改为固定
      const disableHeight = ["cxShare"]
      if (!disableHeight.includes(content?.options?.innerElement)) {
      content.options.height = height
      content.options.heightType = "px"
      }
      content.options.event = getTarComponentEvent({ container_id: ids.container_id, rect_id: ids.rect_id })
      content.active = false
      // 删除和样式无关属性
      delete content.storeOptions
      delete content.preComponent
      delete content.options.multiImageDetail
      content = encryption(content, data_dictionary_map, encType)
      return content
    },
    getElHeight(ids) {
      const { container_id, rect_id } = ids
      let height = document.getElementsByClassName(this.$event.getIdsByStrId({ container_id, rect_id }))[0].offsetHeight
      if (ids.elementInLayoutId !== undefined || isExist(ids.elementInAutoLayoutId) || isExist(ids.elementInSwiperId)) {
        height = document.getElementsByClassName(this.$event.getIdsByStrId(ids))[0].offsetHeight
      }
      return height
    },
    handleParam(encAppId, encType) {
      const param = {}
      const pcElHeight = this.getElHeight(this.ids)
      const content = this.getContent(this.ids, pcElHeight, encType)
      let appContent = sessionStorage.getItem("mobileSystemStyleToPc")
      if (appContent && this.request_prefix !== "appStage") {
        sessionStorage.removeItem("mobileSystemStyleToPc")
        appContent = JSON.parse(appContent)
        appContent = this.getContent(appContent.ids, appContent.height, encType, "appStage")
      }
      /**
       * 因为当前不支持带数据源的样式收藏功能，所以在收藏样式时，将数据源相关的属性去掉，去掉改样式的appId再进行加密收藏
       * TODO
       */
      if (encType === "saveSystemModule") {
        param.a = "7C5C8F204A2F4171"
        param.a2 = encAppId
      } else {
        param.a = encAppId
      }
      param.c = content
      param.c3 = appContent
      return param
    },
    postSaveSystemModule(moduleId, t2) {
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: "保存成功"
      })
      this.$store.dispatch(this.request_prefix + "/updateRectModuleIdTypeId", {
        ...this.ids,
        moduleId: moduleId,
        typeId: t2
      })
      this.dialogFormVisible2 = false
      setTimeout(() => {
        let elementType = this.$store.state.states.elementType
        if(this.isListPage && elementType === "emptyLayoutComponent"){
          let rectAttribute = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
          getSubPageModulesList.call(
            this,
            rectAttribute.options.componentTypeId,
            this.$store.state.states.getDataPageIds.engineInstanceId
          )
        } else {
          getSystemModulesList.call(this, this.systemComponentId)
        }
        this.systemComponentId = null
      }, 100)
      this.collectModuleForm.name = null
      this.systemComponentType = null
      this.systemComponentCover = ""
    },
    // 收藏不带appId的样式，如按钮--设计师使用，用于同网站 不同页面
    collectNoAppIdModule(menuName) {
      let menu =
        this.request_prefix === "bigScreen" ? this.$store.state.bigScreenMenu.menu : this.$store.state.menu.menu
      const activeElementType = this.$store.state.states.elementType
      let elementName
      for (let i = 0; i < menu.children.length; i++) {
        // 地图的type是 "realMapComponent"  componentType是"cxRealMap"
        let element = menu.children[i].children.find(item => item.type === activeElementType || item.componentType === activeElementType)
        if (element) {
          elementName = element.name
          break
        }
      }
      // 对于登录框/搜索这类组件，name是自由布局，和componentTypes返回的名字对应不上
      if (activeElementType === "emptyLayoutComponent" && menuName) {
        elementName = menuName === "自由布局" ? "图文列表" : menuName
      }
      let systemModule = this.componentTypes.find(item => item.label.trim() === elementName)
      if (this.systemComponentId !== systemModule.value) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "请先为当前组件绑定数据源",
          type: "error"
        })
        return
      }
      const { pageId, websiteId } = this.$store.state.states.getDataPageIds
      const param = this.handleParam("", "collect")
      const param1 = {
        t: this.systemModuleForm.name, //名字
        c2: this.systemComponentCover, //封面
        t2: this.systemComponentType || this.systemComponentId, //类型 (比如大屏下的图文)
        w: websiteId,
        p: pageId,
        coll: true //只是自己收藏 添加此参数
      }
      const params = Object.assign({}, param, param1)
      this.instance({
        method: "post",
        url: "v2/collect-module",
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify(params)
      })
        .then(res => {
          console.log("res", res)
          if (res.data.code == 1) {
            let moduleId = res.data.data.moduleId
            this.postSaveSystemModule(moduleId, param1.t2)
          }
        })
        .catch(err => {
          console.log("err", err)
        })
    },
    saveSystemModuleEv() {
      if (this.collectNewVersion && this.screenShotting) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "封面截图中，请稍后再试"
        })
        return
      }
      if (this.systemModuleForm.name !== null) {
        let { pageId, wfwfid } = this.$store.state.states.getDataPageIds
        const _self = this
        // 获取当前组件的appId
        let rectAttribute = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
        const { appId, menuName } = rectAttribute.options ? rectAttribute.options : rectAttribute

        if (!appId) {
          this.collectNoAppIdModule(menuName)
          return
        }
        /*  列表页预设组件，收藏失败，提前添加属性Pageid，实现获取正确的pageid来传递收藏
        举例：列表页预设组件图文列表收藏失败是因为传递的pageid为当前页面的，实际上应该为创建图文列表的首页的pageid，
        * */
        if (rectAttribute.preComponent && rectAttribute.sourcePageId) {
          let pagelist = this.$store.state.states.pageList
          let pageIndex = pagelist.find(item => item.id === rectAttribute.sourcePageId)
          if (!pageIndex) {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: "此页面为脏数据，请删除",
              type: "error"
            })
            return
          } else {
            pageId = pageIndex.publicId
          }
        }
        const param = this.handleParam(appId, "saveSystemModule")
        const param1 = {
          w: wfwfid,
          p: pageId,
          t2: _self.systemComponentType || _self.systemComponentId, //类型 (比如大屏下的图文)
          t: _self.systemModuleForm.name, //名字
          c2: _self.systemComponentCover //封面
        }
        // 判断是不是收藏
        let componentTypeName = _self.componentTypes.find(item => item.value === _self.systemComponentId)
        let styleTypeName = _self.subComponentTypes.find(item => item.value === _self.systemComponentType)
        if (
          componentTypeName &&
          styleTypeName &&
          "我的" + componentTypeName.label.trim() === styleTypeName.label.trim()
        ) {
          //只是自己收藏 添加此参数
          param1.coll = true
        } else if (this.$store.state[this.request_prefix].type === "listPage" && this.isCollect) {
          //兼容列表页的图文列表/文本列表收藏
          param1.coll = true
        }
        const params = Object.assign({}, param, param1)
        this.$API
          .createComponentApp({
            param: params
          })
          .then(res => {
            console.log("res", res)
            if (res.data.code == 1) {
              let moduleId = res.data.data.moduleId
              this.postSaveSystemModule(moduleId, param1.t2)
            }
          })
          .catch(err => {
            console.log("err", err)
          })
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "您输入的数据不正确，请检查内容",
          type: "error"
        })
      }
    },
    saveModuleEv() {
      if (this.collectModuleForm.name !== null) {
        const { pageId, wfwfid } = this.$store.state.states.getDataPageIds
        const _self = this
        const param = this.handleParam("7C5C8F204A2F4171", "collect")
        const param1 = {
          w: wfwfid,
          p: pageId,
          t2: "6D39D43861AF4301",
          t: _self.collectModuleForm.name
        }
        const params = Object.assign({}, param, param1)
        this.$API
          .createComponentApp({
            param: params
          })
          .then(res => {
            if (res.data.code == 1) {
              let moduleId = res.data.data.moduleId
              if (moduleId) {
                initModules.call(_self)

                _self.$message({
                  customClass: "bigScreen_msg_backGroud",
                  duration: 3000,
                  type: "success",
                  message: "保存成功"
                })
                _self.$store.dispatch(_self.request_prefix + "/updateRectModuleIdTypeId", {
                  ..._self.ids,
                  moduleId: moduleId,
                  typeId: param1.t2
                })
                _self.dialogFormVisible = false
              } else {
                this.$message({
                  customClass: "bigScreen_msg_backGroud",
                  duration: 3000,
                  message: "接口请求错误",
                  type: "error"
                })
                _self.dialogFormVisible3 = false
                _self.collectModuleForm.name = null
                _self.collectModuleForm.type = null
                _self.dialogFormVisible = false
              }
            }
          })
          .catch(err => {})
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "您输入的数据不正确，请检查内容",
          type: "error"
        })
      }
    },
    //递归实现
    //@leafId  查找的id，
    //@nodes   原始Json数据
    //@path    供递归使用
    findPathByLeafId(leafId, nodes, path) {
      if (path === undefined) {
        path = {}
      }
      let newNodes = nodes.cols
      for (var i = 0; i < newNodes.length; i++) {
        var tmpPath = path
        if (leafId == newNodes[i].uid) {
          tmpPath = newNodes[i]
          return tmpPath
        }
        if (newNodes[i].rows) {
          for (let j = 0; j < newNodes[i].rows.length; j++) {
            var findResult = this.findPathByLeafId(leafId, newNodes[i].rows[j], tmpPath)
            if (findResult) {
              return findResult
            }
          }
        }
      }
    },
    // 粘贴组件
    pasteComponent(type) {
      let isEditStatu = sessionStorage.getItem("isEditStatu")
      let isInputFocus = sessionStorage.getItem("isInputFocus")
      // isEditStatu isInputFocus 判断不了第三方组件的input输入框聚焦状态, 比如颜色选择器的颜色输入框，用document.activeElement来补充判断
      if (
        isEditStatu ||
        this.copyCompontsData.length === 0 ||
        isInputFocus ||
        document?.activeElement?.tagName === "INPUT"
      ) {
        // 比如文本编辑状态，不调用复制组件
        return
      }
      let _this = this
      this.showRightBtn = false
      let minLeft,
        minTop,
        containerX,
        containerY,
        clientRect = document.getElementById("container_" + this.ids.container_id).getClientRects()[0]
      this.pasteIds = null
      if (
        this.copyCompontsData?.length === 1 &&
        this.ids &&
        Object.keys(this.ids)?.length === 2 &&
        isExist(this.ids.rect_id)
      ) {
        // 判断是否选中通栏布局下的元素
        if (this.isLayout) {
          let handleList = findParentIds(
            this.ids,
            this.$store.state[this.request_prefix].page.pageLayoutType,
            this.$store.state[this.request_prefix]
          )
          this.pasteIds = handleList[1].ids
        } else {
          this.pasteIds = {
            container_id: this.ids.container_id
          }
        }
      }
      if (this.isLayout && this.ids.pageLayoutId !== null && typeof this.ids.pageLayoutId !== "undefined") {
        if (isExist(this.ids.rect_id)) {
          // 通栏组件
          clientRect = document
            .getElementById("rect_id_" + this.ids.rect_id + "_layout_" + this.ids.pageLayoutId)
            .getClientRects()[0]
        } else {
          clientRect = document.getElementById("layout_" + this.ids.pageLayoutId).getClientRects()[0]
        }
      }
      // 判断是否焦点在自由布局上

      let componentNow = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        path: this.ids.path,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId
      })
      let nowInLayout = false
      if (componentNow.shape && componentNow.shape === "layoutComponentBigScreen") {
        nowInLayout = true
        // 注释掉 产品提的新需求选中自由布局复制粘贴需要生效
        // if (!this.ids.uid) {
        //   //自由布局整体不支持粘贴组件，列可以
        //   this.$message({
        //     type: "error",
        //     duration: 2000,
        //     message: "自由布局粘贴需要选中行列！"
        //   })
        //   return
        // }
      }
      if (
        this.request_prefix === "bigScreen" &&
        (_this.pageMouseX < clientRect.left ||
          _this.pageMouseX > clientRect.right ||
          _this.pageMouseY < clientRect.top ||
          _this.pageMouseY > clientRect.bottom)
      ) {
        if (!nowInLayout) {
          return
        }
      }
      containerX = clientRect.left * this.zoom
      containerY = clientRect.top * this.zoom
      //解决报错问题可能导致页面透明度为0.01，获取焦点在画布上，
      // this.$store.commit("states/changeElementType", "page")
      let stage = this.$store.state[this.request_prefix]
      let options = getAttrById(stage, this.ids) // 当前选中格子
      if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
        options = getAttrById(stage, this.ids, "elementInAutoLayout")
      }
      // 在自动布局里面
      if (options?.shape === "cxAutoLayout" || options?.innerElement === "cxAutoLayout") {
        console.log('粘贴到自动布局 :>>');
        let path = options.path
        if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
          if (!options.path) {
            this.$set(options, "path", [])
          }
          path = simpleDeepClone(options.path)
          path.push(this.ids.elementInAutoLayoutId)
        }
        let insertIndex = Array.isArray(options.elementOptions) ? options.elementOptions.length : 0
        this.copyCompontsData.forEach(component => {
          // 不允许自动布局粘贴进单元格下的自动布局
          if (component.innerElement === "cxAutoLayout" && this.ids.uid) return
          if (component.options) {
            // 自动布局外的组件粘贴到自动布局内
            component = simpleDeepClone(component.options)
          }
          component.active = false
          let tmpData = simpleDeepClone(component)
          delete tmpData.moduleId
          delete tmpData.typeId
          delete tmpData.rect_id
          delete tmpData.elementInLayoutId
          delete tmpData.elementInSwiperId
          tmpData.path = path
          if (this.ids.hasOwnProperty("elementInLayoutId")) {
            tmpData.elementInLayoutId = this.ids.elementInLayoutId
          }
          if (this.ids.hasOwnProperty("elementInSwiperId")) {
            tmpData.elementInSwiperId = this.ids.elementInSwiperId
          }
          // 百分比宽高转换 自动布局中只有充满
          tmpData.widthType === "%" ? tmpData.width = 100 : ""
          tmpData.heightType === "%" ? tmpData.height = 100 : ""

          let param = {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: path,
            uid: this.ids.uid,
            elementInLayoutId: this.ids.elementInLayoutId,
            insertIndex: insertIndex,
          }
          deepChangeUid(tmpData)
          if (tmpData.myFetchParam?.appId || tmpData.appId) {
            //更新appid
            const appId = tmpData.myFetchParam?.appId ? tmpData.myFetchParam?.appId : tmpData.appId
            this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, true)
              .then(res => {
                if (!!res.appId) {
                  tmpData.appId = res.appId
                  // 克隆的组件需要将原组件的子页面相关id清空
                  delete tmpData.detailPageId
                  delete tmpData.detailPageTemplateEncId
                  delete tmpData.listPageId
                  delete tmpData.listPageTemplateEncId
                  param.elementOptions = tmpData
                  this.$store.dispatch(this.request_prefix + "/addAutoLayoutElement", param)
                }
              })
              .catch(err => console.log(err))
          } else {
            param.elementOptions = tmpData
            this.$store.dispatch(this.request_prefix + "/addAutoLayoutElement", param)
          }
        })
        return
      }
      // 在列表页数据的单元格里
      if(this.ids.cellId ) {
        // let currCell = options.cells.find(cell => cell.cellId === this.ids.cellId)
        let _this=this
        this.copyCompontsData.forEach(component => {
          component.isActive = false
          let shape = component.innerElement
          // 只有基础组件可以粘贴
          if(_this.baseComponent.indexOf(shape)===-1){
            return
          }
          let tmpData = simpleDeepClone(component)
          const dataOptions = tmpData.options ? tmpData.options : tmpData
          // 自由布局外的组件粘贴到自由布局的列
          if (dataOptions || tmpData.rect_id) {
            let tmpData1 = simpleDeepClone(component)
            tmpData = simpleDeepClone(dataOptions)
            // tmpData.elementInLayoutId = tmpData1.elementInLayoutId
            tmpData.active = false
            delete tmpData.activeCol
          }
          if (!tmpData.hasOwnProperty("isQuickSite") || !tmpData.isQuickSite) {
            tmpData.top = 0
            tmpData.left = 0
          }
          delete tmpData.appId
          delete tmpData.moduleId
          delete tmpData.typeId
          delete tmpData.rect_id
          delete tmpData.elementInAutoLayoutId
          delete tmpData.path
          delete tmpData.cellId
          delete tmpData.elementInDataGridId

          if (tmpData.linkUrl) {
            // 去掉跳转链接
            tmpData.linkUrl = ""
          }
          let param = {
            ...this.ids,
            data: tmpData
          }
          this.$store.dispatch(this.request_prefix + "/addDataGridElement", param)
        })
        return;
      }
      // 在布局里面
      if (
        this.ids.uid ||
        (options?.shape === "emptyLayoutComponent" &&
          options?.options?.pluginName.indexOf("searchComponentPlugin") > -1)
      ) {
        // 搜索组件屏蔽了选中单元
        let uid = this.ids.uid || options.options.rows[0].cols[0].uid
        let stage = this.$store.state[this.request_prefix]
        let tempRect = getAttrById(stage, this.ids, "rect").options
        if (this.ids.elementInAutoLayoutId !== null && typeof this.ids.elementInAutoLayoutId !== "undefined") {
          // 自由布局在自动布局里
          tempRect = getAttrById(stage, this.ids, "elementInAutoLayout")
        }
        let nodes = tempRect.rows
        let curCol
        for (let i = 0; i < nodes.length; i++) {
          curCol = this.findPathByLeafId(uid, nodes[i])
          if (curCol) {
            this.copyCompontsData.forEach(component => {
              component.isActive = false
              let tmpData = simpleDeepClone(component)
              const dataOptions = tmpData.options ? tmpData.options : tmpData
              // 自由布局外的组件粘贴到自由布局的列
              if (dataOptions || tmpData.rect_id) {
                let tmpData1 = simpleDeepClone(component)
                tmpData = simpleDeepClone(dataOptions)
                tmpData.elementInLayoutId = tmpData1.elementInLayoutId
                tmpData.active = false
                delete tmpData.activeCol
              }
              if (!tmpData.hasOwnProperty("isQuickSite") || !tmpData.isQuickSite) {
                tmpData.top = 0
                tmpData.left = 0
              }
              delete tmpData.appId
              delete tmpData.moduleId
              delete tmpData.typeId
              delete tmpData.rect_id
              delete tmpData.elementInAutoLayoutId
              delete tmpData.path

              if (tmpData.linkUrl) {
                // 去掉跳转链接
                tmpData.linkUrl = ""
              }
              let param = {
                rect_id: this.ids.rect_id,
                container_id: this.ids.container_id,
                uid: uid,
                elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
                path: this.ids.path,
                elementOptions: tmpData
              }
              this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
            })
            break
          }
        }
        return
      }
      // 在布局的四边栏里 选中自由布局时也要粘贴进四边栏 顺序依次为上下左右
      if (
        (this.ids.directionIndexOther !== null && typeof this.ids.directionIndexOther !== "undefined") ||
        (this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined") || options?.shape === "emptyLayoutComponent" || options?.innerElement === "emptyLayoutComponent"
      ) {
        const emptyLayout = options?.options ? options?.options : options
        const isShowIndex = emptyLayout?.titleOptions?.findIndex(item => item.isShow)
        let index =
          this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined"
            ? this.ids.directionIndex
            : this.ids.directionIndexOther !== null && typeof this.ids.directionIndexOther !== "undefined"
            ? this.ids.directionIndexOther
            : isShowIndex
        console.log(index)
        if (index === -1) return
        this.copyCompontsData.forEach(component => {
          let isLayoutOrSwiper = this.judgeIsLayoutOrSwiper(component)
          if (isLayoutOrSwiper) {
            return
          }
          component.isActive = false
          let tmpData = simpleDeepClone(component)
          const dataOptions = tmpData.options ? tmpData.options : tmpData
          let isLeftRight = index === 2 || index === 3
          if (isLeftRight) {
            dataOptions.left = 0
            dataOptions.top = 0
          }
          delete dataOptions.rect_id
          let param = {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path,
            direction: index,
            elementOptions: dataOptions
          }
          console.log("param", param)
          this.$store.dispatch(this.request_prefix + "/addComponentInLayoutAround", param)
        })
        return
      }
      // 在轮播组件内
      if (this.ids.hasOwnProperty("swiperContent_id") || this.$store.state.states.elementType === "swiperComponent") {
        let swiperContent_id = this.ids.swiperContent_id
        if (!isExist(swiperContent_id)) {
          const swiper = getAttrById(stage, { container_id: this.ids.container_id, rect_id: this.ids.rect_id }, "rect")
          swiperContent_id = swiper.options.activeCol
        }
        this.copyCompontsData.forEach(component => {
          let isLayoutOrSwiper = this.judgeIsLayoutOrSwiper(component)
          if (isLayoutOrSwiper) {
            return
          }
          component.isActive = false
          let tmpData = simpleDeepClone(component)
          if (component.options) {
            tmpData = simpleDeepClone(component.options)
          }
          delete tmpData.appId
          delete tmpData.moduleId
          delete tmpData.typeId
          delete tmpData.rect_id
          delete tmpData.elementInAutoLayoutId
          delete tmpData.path
          let param = {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            swiperContent_id: swiperContent_id,
            elementOptions: tmpData
          }
          this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
        })
        return
      }
      let focusInput = false
      this.copyCompontsData.forEach(data => {
        //被复制的组件有输入框input获取了焦点，粘贴的时候会粘贴到输入框内，所以需要加属性来标识，不走清除组件选中那一步
        if (data.shape === "cxDatePicker" && data.active) {
          focusInput = true
        }
        const dataOptions = data.options ? data.options : data
        if (!data.hasOwnProperty("rect_id")) {
          return
        }
        if (typeof minTop === "undefined" || dataOptions.top < minTop) {
          minTop = dataOptions.top
        }
        if (typeof minLeft === "undefined" || dataOptions.left < minLeft) {
          minLeft = dataOptions.left
        }
      })
      // todo  在布局模式下 重新计算粘贴的位置
      let mouseX = _this.mouseX,
        mouseY = _this.mouseY
      if ((this.isLayout && !!this.ids.pageLayoutId) || this.activeGridId) {
        mouseX = _this.offsetX
        mouseY = _this.offsetY
        // mouseX = mouseX * this.zoom
        // mouseY = mouseY * this.zoom
      }
      // 复制的组件 重新计算布局高度
      this.copyCompontsData.forEach(data => {
        let tmpData = simpleDeepClone(data)
        const dataOptions = tmpData.options ? tmpData.options : tmpData
        if (!data.hasOwnProperty("rect_id") && !this.activeGridId) {
          return
        }
        // 组件内部不允许复杂组件的粘贴 横向标签布局组件除外
        if(isExist(this.ids.rect_id) && !isExist(this.ids.pageLayoutId) &&
            ['cxDataGrid',"layoutComponent","emptyLayoutComponent","swiperComponent"].indexOf(dataOptions.innerElement)>-1) {
          return
        }
        // if(data.hasOwnProperty("elementInLayoutId") && data.elementInLayoutId !== null && typeof data.elementInLayoutId !== 'undefined'){
        //   // 将自由布局里的组件 粘贴在普通布局中  不允许这么操作
        //   return
        // }
        tmpData.active = false
        delete tmpData.appId
        delete tmpData.moduleId
        delete tmpData.typeId

        // delAnimateGroup(tmpData.options ? tmpData.options : tmpData)
        let inBigscreenLayout = false
        if (this.activeGridId && tmpData.options) {
          tmpData.i = this.activeGridId
        }
        if (this.request_prefix == "bigScreen" && data.shape === "layoutComponentBigScreen") {
          //大屏的自由布局复制需要，修改uid是为了解决复制出来的自由布局列选中，会影响到被复制的组件列选中
          deepChangeUid(tmpData) // 不要了，放在添加的时候处理
          inBigscreenLayout = true
        }
        let top
        let isBase = this.baseComponent.find(item => {
          return (
            item.indexOf(dataOptions.innerElement) > -1 ||
            // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
            dataOptions.pluginName?.indexOf("ListPageSearchComponentPlugin") > -1
          )
        })
        if (dataOptions.isQuickSite) {
          dataOptions.isQuickSite = false
          dataOptions.margin = 0
          dataOptions.offset = 0
          dataOptions.leftType = "px"
          dataOptions.topType = "px"
          // 基础组件直接放在布局里的情况，快捷定位的时候不处理位置
        }
        if (this.isLayout && (!!this.ids.pageLayoutId || this.activeGridId || this.pasteIds)) {
          if (type === "ctrlv") {
            // 被复制组件位置为百分比则保留 不是则判断是否是相同布局，是偏移10，10 不同布局则清空
            let isSomeLayout = this.activeGridId === data.i
            if (this.ids.pageLayoutId && isExist(data.rect_id)) {
              const path = findCurrentComponentPathInLayoutByRectId(this.pageLayoutList, data.rect_id).join("_")
              isSomeLayout = path === this.ids.pageLayoutId
            }
            console.log("isSomeLayout :>>", isSomeLayout)
            dataOptions.left =
              dataOptions.leftType !== "%"
                ? isSomeLayout || this.pasteIds
                  ? dataOptions.left + 10
                  : 0
                : dataOptions.left
            dataOptions.top =
              dataOptions.topType !== "%" ? (isSomeLayout || this.pasteIds ? dataOptions.top + 10 : 0) : dataOptions.top
          } else {
            dataOptions.left =
              dataOptions.leftType === "%"
                ? dataOptions.left
                : this.pasteIds
                ? dataOptions.left + 10
                : dataOptions.left + parseInt(parseInt(mouseX)) - minLeft
            dataOptions.top =
              dataOptions.topType === "%"
                ? dataOptions.top
                : this.pasteIds
                ? dataOptions.top + 10
                : dataOptions.top + parseInt(parseInt(mouseY)) - minTop
          }
          top = mouseY
          if (!isBase) {
            dataOptions.left = 0
            dataOptions.top = 0
            top = 0
          }
        } else if (this.request_prefix === "bigScreen" && this.zoom < 1) {
          if (type === "ctrlv" || this.pasteIds) {
            // 舒斐定的 快捷键粘贴不跟随鼠标，原定位偏移值+10
            dataOptions.left = dataOptions.left + 10
            dataOptions.top = dataOptions.top + 10
          } else {
            dataOptions.left = parseInt((parseInt(mouseX) - clientRect.left) / this.zoom)
            dataOptions.top = parseInt((parseInt(mouseY) - clientRect.top) / this.zoom)
            top = parseInt((parseInt(mouseY) - clientRect.top) / this.zoom)
          }
        } else {
          // todo 定位设置为百分比的情况待优化
          dataOptions.left =
            parseInt(dataOptions.left) + parseInt((parseInt(mouseX) - containerX) / this.zoom) - minLeft
          dataOptions.top = parseInt(dataOptions.top) + parseInt((parseInt(mouseY) - containerY) / this.zoom) - minTop
          top = parseInt(dataOptions.top) + parseInt((parseInt(mouseY) - containerY) / this.zoom) - minTop
        }
        if (dataOptions.myFetchParam?.appId || dataOptions.appId) {
          //更新appid
          const appId = dataOptions.myFetchParam?.appId ? dataOptions.myFetchParam?.appId : dataOptions.appId
          this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, true)
            .then(res => {
              if (!!res.appId) {
                dataOptions.appId = res.appId
                // 克隆的组件需要将原组件的子页面相关id清空
                delete dataOptions.detailPageId
                delete dataOptions.detailPageTemplateEncId
                delete dataOptions.listPageId
                delete dataOptions.listPageTemplateEncId
                this.addRect(tmpData, isBase, data)
              }
            })
            .catch(err => console.log(err))
        } else {
          this.addRect(tmpData, isBase, data)
          //查找新生成的最大的rect_id
          const stage = this.$store.state[this.request_prefix]
          const allRects = this.getAttrById.call(this, stage, { container_id: this.ids.container_id }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          // 处理自由布局内的基础组件的嗯appid
          let tmpData1 = getAttrById(stage, { container_id: this.ids.container_id, rect_id: _rect_id }, "rect")
          handleChildAppid.call(this, tmpData1, this.ids.container_id)
        }
      })
      if (!this.isLayout && !focusInput) {
        // this.clearRectId()
        // 上面那个方法清除rectId并没有清除选中状态 再次修改元素属性会报错 以大屏选中自由布局粘贴元素为例
        this.handdleClearActive()
      }
    },
    // 判断是不是自由布局，自由布局不能粘贴在自由布局边栏，轮播里
    judgeIsLayoutOrSwiper(tmpData) {
      if (
        tmpData.shape === "emptyLayoutComponent" ||
        tmpData.shape === "layoutComponent" ||
        tmpData.shape === "swiperComponent"
      ) {
        return true
      }
      return false
    },
    // 添加组件
    addRect(tmpData, isBase, data) {
      // 如果是布局，不是最后一层，也取消粘贴功能
      if (this.isLayout && !!this.ids.pageLayoutId) {
        let pageLayout = $(`#layout_${this.ids.pageLayoutId}`)
        if (isExist(this.ids.rect_id)) {
          pageLayout = $(`#rect_id_${this.ids.rect_id}_layout_${this.ids.pageLayoutId}`)
        }
        let layoutCell = pageLayout.find(".layout-columns")
        if (layoutCell.length > 1) {
          return
        }
      }
      if (!isBase && this.isLayout && !!this.ids.pageLayoutId) {
        // 当他不为基础组件的时候，需要考虑布局里面之后放一个非基础组件
        let pageLayout = $(`#layout_${this.ids.pageLayoutId}`)
        if (isExist(this.ids.rect_id)) {
          pageLayout = $(`#rect_id_${this.ids.rect_id}_layout_${this.ids.pageLayoutId}`)
        }
        let fullRect = pageLayout.find(".is_full_rect")
        if (fullRect.length > 0) {
          return
        }
      }
      let isOpenState
      if (this.isAccordionLayout) {
        let ids = this.ids.pageLayoutId?.toString().split("_")
        let layoutId = ids[ids.length - 1]
        isOpenState = this.openIndex === Number(layoutId) ? true : false
      }
      let newTmpData = {}
      if (tmpData.hasOwnProperty("options")) {
        if (isExist(tmpData.elementInLayoutId)) {
          // 复制四边栏的元素到通栏里
          tmpData.shape = tmpData.innerElement
          delete tmpData.innerElement
          delete tmpData.elementInLayoutId
          delete tmpData.options.filedMapping
          delete tmpData.options.elementInLayoutId
        }
        newTmpData = simpleDeepClone(tmpData)
      } else {
        delete tmpData.elementInLayoutId
        delete tmpData.elementInSwiperId
        delete tmpData.elementInAutoLayoutId
        delete tmpData.filedMapping
        newTmpData.rect_id = tmpData.rect_id
        delete tmpData.rect_id
        newTmpData.options = simpleDeepClone(tmpData)
        if (this.activeGridId) newTmpData.i = this.activeGridId
        newTmpData.shape = tmpData.innerElement
      }
      if (this.isAccordionLayout) {
        newTmpData.options.isOpenState = isOpenState
      }
      this.$store.commit(this.request_prefix + "/ELEMENT_ADD", {
        containerID: this.ids.container_id,
        data: newTmpData
      })
      //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
      const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.ids.container_id
      }).children
      // let _rect_id = allRects.length ? allRects[allRects.length - 1].rect_id : -1
      // 布局模式下需要添加对应的rectId到布局中
      if (
        this.isLayout &&
        data.hasOwnProperty("rect_id") &&
        (!!this.ids.pageLayoutId || this.activeGridId || this.pasteIds)
      ) {
        let copyComponent = document.getElementsByClassName(
          `container_id_${this.ids.container_id}-rect_id_${data.rect_id}`
        )[0]
        // let copyComponentHeight = copyComponent.getBoundingClientRect().height + parseInt(top)
        let copyComponentHeight = copyComponent.getBoundingClientRect().height
        this.addRectToPageLayout(copyComponentHeight, isBase)
      }
    },
    addRectToPageLayout(copyComponentHeight, isBase) {
      const stage = this.$store.state[this.request_prefix]
      const allRects = this.getAttrById.call(this, stage, { container_id: this.ids.container_id }).children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      let layoutIndex = this.ids.pageLayoutId
        ? this.ids.pageLayoutId
        : this.waterFallLayoutId
        ? this.waterFallLayoutId
        : this.pasteIds?.pageLayoutId
      let pageLayout = this.getAttrById(stage, { pageLayoutId: layoutIndex }, "pageLayout")
      if (isExist(this.ids.rect_id) && !this.pasteIds) {
        // 标签布局组件
        pageLayout = this.getAttrById(stage, this.ids, "pageLayout")
      }
      pageLayout.rectIds.push(_rect_id)
      let param = {
        ...this.ids,
        option_name: "rectIds",
        option_val: pageLayout.rectIds
      }
      this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      // 非基础组件才进行 布局高度的调整
      if (this.isLayout && !isBase && copyComponentHeight) {
        this.changeCellSize({
          ...this.ids,
          height: copyComponentHeight
        })
      }
    },
    // 复制样式后 查看当前布局高度是否需要修改
    changeCellSize(data) {
      if (!isExist(data.pageLayoutId) || data.pageLayoutId.toString().length === 0) {
        return
      }
      // 根据ids 查找当前选中组件的布局
      let activeLayoutIndex = data.pageLayoutId
      let parentLayoutIndex = activeLayoutIndex.split("_")
      let curIndex = parentLayoutIndex[parentLayoutIndex.length - 1]
      parentLayoutIndex.pop()

      let parentLayout = this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: data.container_id,
          pageLayoutId: parentLayoutIndex.join("_")
        },
        "pageLayout"
      )
      let curCellIsCol = parentLayout.layout.cols && parentLayout.layout.cols.length > 0 ? true : false
      let activeLayout = curCellIsCol ? parentLayout.layout.cols[curIndex] : parentLayout.layout.rows[curIndex]
      let ultimateHeight = curCellIsCol ? Math.max(data.height, activeLayout.options.height) : data.height
      // 如果当前为col  兄弟元素的高度一起撑高
      if (curCellIsCol) {
        parentLayout.layout.cols.forEach((layout, index) => {
          layout.options.height = ultimateHeight
        })
      } else {
        parentLayout.layout.rows.forEach((layout, index) => {
          if (index == curIndex) {
            layout.options.height = ultimateHeight
          }
        })
      }
      // 当高度大于父元素高度的时候，单独处理
      parentLayoutIndex = parentLayoutIndex.join("_")
      this.setParentLayoutH(parentLayoutIndex, curIndex)
    },
    // 设置子元素的高度
    setChildLayoutH(editProp, child) {
      if (child.layout.rows.length === 0 && child.layout.cols.length === 0) {
        // 没有子元素啦
        return
      }
      let curCellIsRow = child.layout.rows.length > 0 ? true : false
      let layout = curCellIsRow ? child.layout.rows : child.layout.cols
      layout.forEach(item => {
        item.options.height = item.options.height * editProp
        this.setChildLayoutH(editProp, item)
      })
    },
    // 设置父元素的高度
    setParentLayoutH(parentId, curIndex) {
      let parentH = 0
      let ids = parentId.split("_")
      let lastIndex = parseInt(ids[ids.length - 1])
      let parentLayout = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        { container_id: this.id, pageLayoutId: parentId },
        "pageLayout"
      ).layout
      if (parentLayout.rows.length > 0) {
        parentLayout.rows.forEach(item => {
          parentH += parseFloat(item.options.height)
        })
      } else if (parentLayout.cols.length > 0) {
        parentH = parentLayout.cols[curIndex].options.height
        parentLayout.cols.forEach((item, index) => {
          if (index === curIndex) {
            return
          }
          let editProp = parentH / item.options.height
          item.options.height = parentH
          this.setChildLayoutH(editProp, item)
        })
      } else {
        return
      }
      this.$changeOptionsEV(
        parentH,
        "height",
        false,
        "",
        {
          container_id: this.id,
          pageLayoutId: parentId
        },
        true
      )

      let newIds = parentId.split("_")
      newIds.splice(newIds.length - 1, 1)
      if (newIds.length > 0) {
        newIds = newIds.join("_")
        this.setParentLayoutH(newIds, lastIndex)
      }
    },
    clearRectId() {
      let ids = {
        container_id: this.ids.container_id
      }
      this.$store.commit("states/changeActiveID", ids)
    },

    // 按照从大到小排序
    compare(propertyName) {
      return function (object1, object2) {
        var value1 = object1[propertyName]
        var value2 = object2[propertyName]
        if (value2 > value1) {
          return 1
        } else if (value2 < value1) {
          return -1
        } else {
          return 0
        }
      }
    },
    // 按照从小到大排序
    compare1(propertyName) {
      return function (object1, object2) {
        var value1 = object1[propertyName]
        var value2 = object2[propertyName]
        if (value2 < value1) {
          return 1
        } else if (value2 > value1) {
          return -1
        } else {
          return 0
        }
      }
    },
    // 成组
    inGroup() {
      let _this = this
      let copyComponents = this.copyComponent()

      let hasLayoutComponent = false
      for (let i = 0; i < copyComponents.length; i++) {
        if (copyComponents[i].uid) {
          hasLayoutComponent = true
          break
        } else if (_this.copyCompontsData[i].shape === "layoutComponentBigScreen") {
          //自由布局不支持编组功能
          hasLayoutComponent = true
          break
        }
      }
      if (hasLayoutComponent) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "info",
          message: "复杂组件不能成组"
        })
        return
      }
      copyComponents.sort(this.compare1("rect_id"))
      let components = []
      copyComponents.forEach(item => {
        let thisIds = {
          container_id: item.container_id,
          rect_id: item.rect_id
        }
        let hasExist = false
        for (let i = 0; i < components.length; i++) {
          if (JSON.stringify(components[i]) === JSON.stringify(thisIds)) {
            hasExist = true
            break
          }
        }
        if (!hasExist) {
          components.push(thisIds)
        }
      })
      let idsCopy = { ..._this.ids }
      components.forEach(component => {
        _this.$store.dispatch(this.request_prefix + "/deleteElement", {
          containerId: component.container_id,
          rectId: component.rect_id
        })
      })
      this.copyCompontsData.sort(this.compare1("rect_id"))
      if (this.copyCompontsData.length > 1) {
        let minTop, minLeft, containerW, containerH
        let data = simpleDeepClone(bigScreen_emptylayout_children[0].attribute)
        // 隐藏掉标题，tab等
        data.options.titleOptions.forEach((title, index) => {
          if (title && title.hasOwnProperty("elementOptions") && Array.isArray(title.elementOptions)) {
            title.elementOptions.forEach(element => {
              element.isShow = false
            })
          }
        })
        this.copyCompontsData.forEach(data => {
          let maxR = parseFloat(data.options.left) + parseFloat(data.options.width)
          let maxH = parseFloat(data.options.top) + parseFloat(data.options.height)
          if (typeof containerW === "undefined" || containerW < maxR) {
            containerW = maxR
          }
          if (typeof containerH === "undefined" || containerH < maxH) {
            containerH = maxH
          }
          if (typeof minTop === "undefined" || data.options.top < minTop) {
            minTop = data.options.top
          }
          if (typeof minLeft === "undefined" || data.options.left < minLeft) {
            minLeft = data.options.left
          }
        })
        let border = data.options.borderWidth
          ? Array.isArray(data.options.borderWidth) && data.options.borderWidth.length > 0
            ? data.options.borderWidth
            : [data.options.borderWidth, data.options.borderWidth, data.options.borderWidth, data.options.borderWidth]
          : [0, 0, 0, 0]
        data.options.left = parseInt(minLeft)
        data.options.top = parseInt(minTop)
        data.options.width = parseInt(containerW - minLeft) + border[1] + border[3]
        data.options.height = parseInt(containerH - minTop) + border[0] + border[2]
        data.options.disableSetColAndRow = true //添加成组后的组件，因为有解组功能，不能进行行列设置
        let newComponent = []
        console.log(this.copyCompontsData)
        this.copyCompontsData.forEach((component, index) => {
          component.options.left = component.options.left - minLeft
          component.options.top = component.options.top - minTop
          component.options.elementInLayoutId = index
          newComponent.push(component.options)
        })
        data.options.rows[0].cols[0].elementOptions = newComponent
        data.options.rows[0].cols[0].componentBoxOptions.bgColor = "transparent"
        data.options.rows[0].cols[0].disableSetColAndRow = true //添加成组后的组件，因为有解组功能，不能进行行列设置
        data.options.rows[0].cols[0].uid = uuid.v1()
        // deepChangeUid(data)
        data.options.rows[0].cols[0].uid = uuid.v1()
        _this.$store.dispatch(this.request_prefix + "/addElement", {
          containerID: idsCopy.container_id,
          data: data
        })
        this.ids = {
          container_id: idsCopy.container_id,
          rect_id: data.rect_id
        }
        if (this.request_prefix === "bigScreen") {
          this.$store.commit("states/changeElementType", "layoutComponentBigScreen")
        } else {
          this.$store.commit("states/changeElementType", "layoutComponent")
        }
        this.$store.commit("states/changeShowLeftMenuStatus", true)
      }
    },
    // 取消成组
    cancleGroup() {
      if (this.ids.container_id === null || this.ids.rect_id === null) {
        return
      }
      let options = this.$getOptions({
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      })
      let idsCopy = { ...this.ids }
      if (!options.hasOwnProperty("disableSetColAndRow") || options.disableCancleGroup) {
        return
      }
      let containerLeft = options.left,
        containerTop = options.top,
        result = simpleDeepClone(options.rows[0].cols[0].elementOptions)
      this.$store.commit("states/changeElementType", null)
      this.$store.dispatch(this.request_prefix + "/deleteElement", {
        containerId: idsCopy.container_id,
        rectId: idsCopy.rect_id
      })
      this.$store.commit("states/changeActiveID", {
        container_id: idsCopy.container_id
      })
      result.forEach((component, index) => {
        component.left = component.left + containerLeft
        component.top = component.top + containerTop
        delete component.elementInLayoutId
        // let newComponent = new VDRAttribute(component.innerElement, component)
        let newComponent = {
          active: false,
          shape: component.innerElement,
          options: {
            ...component
          },
          ...new VDRAttribute()
        }
        this.$store.dispatch(this.request_prefix + "/addElement", {
          containerID: idsCopy.container_id,
          data: newComponent
        })
        //解决在编辑页取消编组之后最前面的组件的层级最高的情况
        if (index === 0) {
          const stage = this.$store.state[this.request_prefix]
          const allRects = this.getAttrById.call(this, stage, { container_id: this.ids.container_id }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          let rectEl = document.getElementsByClassName(
            this.$event.getIdsByStrId({ container_id: this.ids.container_id, rect_id: _rect_id })
          )[0]
          if (rectEl) rectEl.style.zIndex = 0
        }
      })
      this.showRightBtn = false
    },
    // 上一层
    upperLevel() {
      const _ids = { ...this.ids }
      // delete _ids.swiperContent_id
      let component = this.getAttrById.call(this, this.$store.state[this.request_prefix], _ids)
      let options = component.options ? component.options : component
      let level = options.zIndex ? options.zIndex : 0
      this.showRightBtn = false
      this.$changeOptionsEV(level + 1, "zIndex", null, false, _ids)
    },
    // 下一层
    lowerLevel() {
      const _ids = { ...this.ids }
      // delete _ids.swiperContent_id
      let component = this.getAttrById.call(this, this.$store.state[this.request_prefix], _ids)
      let options = component.options ? component.options : component
      let level = options.zIndex ? options.zIndex : 0
      this.showRightBtn = false
      if (level === 0) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: "已经是最底层啦"
        })
        return
      }
      this.$changeOptionsEV(level - 1, "zIndex", null, false, _ids)
    },
    //移到顶层
    upperLevel1() {
      const _ids = { ...this.ids }
      this.moveLevelFunc(_ids, "bottom")
    },
    //移到底层
    lowerLevel1() {
      const _ids = { ...this.ids }
      this.moveLevelFunc(_ids, "top")
    },
    moveLevelFunc(_ids, type) {
      let activeIndex = 0
      if (_ids.uid) {
        const rectAttr = this.getRectAttribute.call(this, this.ids)
        const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
        const pOptions = [rectAttr.options.rows[useActiveIndex]]
        const colOptions = handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid)
        let colList = colOptions.elementOptions
        colList.forEach((item, index) => {
          if (item.isActive) {
            activeIndex = index
          }
        })
        if (type === "top") {
          this.handleTop(activeIndex, colList)
        } else if (type === "bottom") {
          this.handleBottom(activeIndex, colList)
        }
      } else if (isExist(_ids.swiperContent_id) && isExist(_ids.elementInSwiperId)) {
        const rectAttr = this.getRectAttribute.call(this, this.ids)
        const elementOptions = rectAttr.options.content[_ids.swiperContent_id].elementOptions
        elementOptions.forEach((item, index) => {
          if (item.isActive) {
            activeIndex = index
          }
        })
        if (type === "top") {
          this.handleTop(activeIndex, elementOptions)
        } else if (type === "bottom") {
          this.handleBottom(activeIndex, elementOptions)
        }
      } else {
        let childrens = this.dataSource.children[0].children
        childrens.forEach((item, index) => {
          if (item.rect_id === _ids.rect_id) {
            activeIndex = index
          }
        })
        if (type === "top") {
          this.handleTop(activeIndex, childrens)
        } else if (type === "bottom") {
          this.handleBottom(activeIndex, childrens)
        }
      }
      this.$store.commit("states/changeIsUpdateLayerDataFlag", true)
      this.showRightBtn = false
    },
    // 置顶
    handleTop(index, arrList) {
      // 将要置顶的元素存储后删除
      const temp = arrList.splice(index, 1)[0]
      // 将元素unshift到数组第一位
      arrList.unshift(temp)
    },
    // 置底
    handleBottom(index, arrList) {
      // 将要置底的元素存储后删除
      const temp = arrList.splice(index, 1)[0]
      // 将元素push到数组最后一位
      arrList.push(temp)
    },
    getRects() {
      const totalH =
        this.dataSource.children.length > 1
          ? this.dataSource.children.reduce(
              (prev, curr) => (typeof prev === "number" ? prev : prev.height) + curr.height
            )
          : this.dataSource.children[0].height
      let res = new Array(Math.ceil(totalH / 100))
      for (let i = 0; i < res.length; i++) {
        res[i] = []
      }
      let containerHCount = 0
      let containerSource = this.dataSource.children
      if (this.isLayout) {
        containerSource = [containerSource[0]]
      }
      for (let i = 0; i < containerSource.length; i++) {
        const container = containerSource[i]
        for (let j = 0; j < container.children.length; j++) {
          const rect = container.children[j]
          const rectT = containerHCount + rect.options.top
          res[Math.floor(rectT / 100)].push({
            top: rectT,
            ids: { container_id: container.container_id, rect_id: rect.rect_id },
            animateTriggerNumType: rect.options.animateSets.executionAnimateClass !== "单次触发",
            pageloadAnimates: rect.options.pageloadAnimates
          })
        }
        containerHCount += container.height
      }
      this.rects = res
    },
    handleScroll: _throttle(function () {
      //  将有动画的组件先筛选出来
      if (!this.animateRects || this.animateRects.length === 0) {
        return
      }
      const arr = this.animateRects
      if (this.timerByScroll !== null) clearTimeout(this.timerByScroll)
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i]
        if (item.pageloadAnimates && item.pageloadAnimates.length > 0) {
          let currentDomClass = `container_id_${item.ids.container_id}-rect_id_${item.ids.rect_id}`
          currentDomClass = item.ids.uid ? `${currentDomClass}-uid_${item.ids.uid}` : currentDomClass
          let animateDom = document.getElementsByClassName(currentDomClass)[0]
          if (!animateDom) {
            continue
          }
          let domSite = animateDom.getBoundingClientRect()
          let domTop = domSite.top
          let windowH = document.documentElement.offsetHeight
          if (domTop > windowH || domTop < 0) {
            animateDom.removeAttribute("animated")
            continue
          }
          let isAnimate = domTop < windowH / 2
          let hasAnimated = animateDom.getAttribute("animated")
          if (!isAnimate || hasAnimated) {
            //  不在可视区域，或者在可视区域已经执行了动画，则不再执行
            continue
          }
          // 可视区域内 只执行一次动画
          animateDom.setAttribute("animated", "true")
          let animateIds = [],
            passiveIds = [],
            animateDuration = "",
            animateDelay = ""
          item.pageloadAnimates.forEach(animate => {
            // 对比controlIds 是不是等于当前对象的id
            let isCurrentIds = compareIds(animate.controlIds, animate.ids)
            if (isCurrentIds) {
              animateIds.push(animate.animateId)
              passiveIds = passiveIds.concat(animate.passiveIds)
              animateDuration +=
                animateDuration.length > 0 ? `,${animate.animateDuration}ms` : `${animate.animateDuration}ms`
              animateDelay += animateDelay.length > 0 ? `,${animate.animateDelay}ms` : `${animate.animateDelay}ms`
            }
          })
          this.handlePassiveAnimate(passiveIds, animateIds, animateDuration, animateDelay, "pageload")
        }
      }
      this.timerByScroll = setTimeout(() => {
        this.rects = null
        this.timerByScroll = null
        this.curr = null
        this.prev = null
      }, 300)
    }, 100),
    changeActiveStage(id, index) {
      // 选中当前容器
      const acId = this.$store.getters["menu/getActiveMenu"]
      // 选中当前容器
      const _stage = this.$store.state[this.request_prefix]
      if (!this.getAttrById(_stage, { container_id: id }).isActive)
        this.$store.commit("states/changeActiveID", { container_id: id })
      this.$store.dispatch(this.request_prefix + "/setContainerActive", { container_id: id })
      this.$store.commit(
        "states/changeElementType",
        this.request_prefix.includes("bigScreen") ? "bigScreenContainer" : "container"
      )
    },
    // 上一页
    prevPage() {
      if (this.showStageIndex > 0) {
        this.showStageIndex = this.showStageIndex - 1
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "info",
          message: "当前已经是第一页了"
        })
      }
    },
    // 下一页
    nextPage() {
      if (this.showStageIndex < this.dataSource.children.length - 1) {
        this.showStageIndex = this.showStageIndex + 1
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "info",
          message: "当前已经是最后一页了"
        })
      }
    },
    musicStop() {
      this.isMusicStop = true
      this.$refs.bgMusic.pause()
    },
    musicPlay() {
      this.isMusicStop = false
      this.$refs.bgMusic.play()
    },
    musicEnd() {
      !this.dataSource.bgMusicLoop ? (this.isMusicStop = true) : ""
    },
    changeComponentType(val) {
      let childIndex,
        subComponentTypes = []
      for (let i = 0; i < this.allSubComponentTypes.length; i++) {
        if (this.allSubComponentTypes[i].value === val) {
          subComponentTypes = this.allSubComponentTypes[i]
          childIndex = i
          break
        }
      }
      subComponentTypes = subComponentTypes?.subs || []
      let list = []
      subComponentTypes.forEach(item => {
        if (this.isCollect == 1) {
          if (item.name.indexOf("我的") > -1) {
            list.push({
              label: item.name,
              value: item.encId
            })
          }
        } else {
          if (item.name.indexOf("我的") === -1) {
            list.push({
              label: item.name,
              value: item.encId
            })
          }
        }
      })
      if (list.length === 0) {
        //获取三级分类
        this.componentTypes.find(data => {
          if (data.value === val) {
            subComponentTypes = data.subs
          }
        })
        subComponentTypes.forEach(item => {
          if (this.isCollect == 1) {
            if (item.name.indexOf("我的") > -1) {
              list.push({
                label: item.name,
                value: item.encId
              })
            }
          } else {
            if (item.name.indexOf("我的") === -1) {
              list.push({
                label: item.name,
                value: item.encId
              })
            }
          }
        })
        this.allSubComponentTypes.push({
          value: val,
          subs: subComponentTypes
        })
      }
      this.subComponentTypes = list
      this.systemComponentType = this.subComponentTypes[0]?.value // 默认选中第一个
    },
    // 移动端同步pc端的数据
    async syncBtnData() {
      if (this.isOnlyPhonePageFlag) {
        return
      }
      this.$emit("syncData")
    },
    openSystemLayoutDialog(param, isCollect) {
      this.dialogSystemLayout = true
      this.isCollectSystemLayout = isCollect
      this.selectPageLayout = param
    },
    // 同步当前col
    async syncCol() {
      let allCols = sessionStorage.getItem("allCols")
      allCols = JSON.parse(allCols)
      sessionStorage.removeItem("allCols")
      this.before = this.getQuickShot()
      if (allCols) {
        for (let i = 0; i < allCols.length; i++) {
          if (allCols[i].isChecked) {
            const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
            const pOptions = [this.getOptions.rows[useActiveIndex]]
            const baseId = {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path
            }
            const result = {
              ...baseId,
              baseUid: this.ids.uid,
              content: simpleDeepClone(handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid)),
              uid: allCols[i].uid
            }
            this.$event.mergeEvent(
              {
                from: { ...baseId, uid: this.ids.uid },
                to: { ...baseId, uid: allCols[i].uid }
              },
              "col"
            )
            this.$store.dispatch(this.request_prefix + "/changeLayoutComponentBoxOption", result)
            //大屏自由布局内 复制克隆出来的自由布局内部的组件需要修改appid
            if (this.request_prefix == "bigScreen" && (this.getOptions.innerElement === "layoutComponentBigScreen" || this.getOptions.innerElement === "emptyLayoutComponent")) {
              let attr1 = handleFindLayoutComponentOptionsCols(pOptions, allCols[i].uid)
              console.log("attr1", attr1, attr1.uid)
              if (attr1) {
                //修改克隆出来的内部组件
                let elements = attr1.elementOptions
                if (elements.length > 0) {
                  for (let i = 0; i < elements.length; i++) {
                    if (elements[i].appId) {
                      await this.$styleToSaveModule("31CB73E03E24BBFF", "临时", elements[i].appId, true).then(res => {
                        if (!!res.appId) {
                          console.log("改变appid", elements[i].appId, res.appId)
                          elements[i].appId = res.appId
                        }
                      })
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isClonePattern",
        val: false
      })
      this.addHistory()
      // 模拟点击
      let getDataBtn = document.getElementsByClassName("toolbar")[0].getElementsByClassName("getDataBtn")
      if (getDataBtn.length > 0) {
        getDataBtn[0].click()
      }
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      return deepCloneAndFreeze(rect)
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    },
    cancelOrder() {
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isOrderPattern",
        val: false
      })
      sessionStorage.removeItem("allCols")
    },
    resetOrder() {
      const allCols = JSON.parse(sessionStorage.getItem("allCols"))
      allCols.forEach(col => {
        col.order = 0
        col.isChecked = false
      })
      sessionStorage.setItem("allCols", JSON.stringify(allCols))
      window.postMessage({ type: "resetOrder" })
    //  选中的组件状态被取消，需要补上
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      rectAttr.active = true
    },
    saveOrder() {
      const allCols = JSON.parse(sessionStorage.getItem("allCols"))
      const allChecked = allCols.reduce((a, b) => a && b.isChecked, true)
      if (!allChecked) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: "单元格未排序完成"
        })
        return
      }
      this.before = this.getQuickShot()
      const orderArr = allCols.sort((a, b) => a.order - b.order).map(col => col.uid)
      sessionStorage.removeItem("allCols")
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isOrderPattern",
        val: false
      })
      // const rectAttr = this.getRectAttribute.call(this, this.ids)
      const rectAttr = this.getAttrById(this.$store.state[this.request_prefix], this.ids)
      let { renderOrder, activeIndex } = rectAttr.options ? rectAttr.options : rectAttr
      // 旧数据格式不同的清除重做
      if (Array.isArray(renderOrder)) {
        renderOrder = {}
      }
      const newRenderOrder = Object.assign(renderOrder || {}, { [activeIndex]: orderArr })
      this.$changeOptionsEV(
        newRenderOrder,
        "renderOrder",
        null,
        false,
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          path: this.ids.path,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId
        },
        true
      )
      this.addHistory()
      // 模拟点击
      let getDataBtn = document.getElementsByClassName("toolbar")[0].getElementsByClassName("getDataBtn")
      if (getDataBtn.length > 0) {
        getDataBtn[0].click()
      }
    },
    //去帮助中心
    gotoHelpCenter() {
      window.open("https://fe.chaoxing.com/front/subject/index.html#/details/4d4b95d7-6526-47ec-9e86-f6575a97f980")
    },
    // 展示当前应用的信息
    showRectInfoClick(){
       this.showRightBtn = false
       this.dialogEditComponentId = true
    },
    // 通栏布局设置按钮点击
    pageLayoutClick(flag) {
      let pageLayoutId = this.ids.pageLayoutId
      let list = this.$store.state[this.request_prefix].page.pageLayoutList
      let parent = ""
      if (this.showLayoutSet) {
        let pageLayout = list[pageLayoutId]
        parent = $(`.pageLayout_id_${pageLayout.id}`)
      } else if (this.showCellSet) {
        parent = $(`#layout_${pageLayoutId}`)?.siblings(".layout-sets")
      } else if (this.showColSet) {
        parent = $(`#${this.ids.uid}`)
      }
      switch (flag) {
        case 0: //设为系统样式
          parent?.find(".upload-pageLayout")[0].click()
          break
        case 1: //收藏
          parent?.find(".collect-pageLayout")[0].click()
          break
        case 2: //复制
          parent?.find(".copy-click")[0].click()
          break
        case 3: //同步到移动端
          parent?.find(".sync-pageLayout")[0].click()
          break
        case 4: //新增到移动端
          parent?.find(".add-click")[0].click()
          break
        case 5: //删除
          parent?.find(".del-click")[0].click()
          break
        case 6: //同步原始样式
          parent?.find(".unboundApp-pageLayout")[0].click()
          break
        case 7: //复制通栏链接
          this.copyPageLayoutLink(pageLayoutId)
          break
        default:
      }
      this.showRightBtn = false
    },
    copyPageLayoutLink(pageLayoutId) {
      this.$store.commit("states/changeCopyLinkStatus", true)
      document.querySelector(".previewSave .previewBtn").click()
      this.copyingPageLayoutId = this.$store.state[this.request_prefix].page.pageLayoutList[pageLayoutId].id
      this.$eventBus.$on("after-copyLick-generate", this.generateCopyLink)
    },
    generateCopyLink(link) {
      let copyLink = replaceUrlParam(link, "layTarget", this.copyingPageLayoutId)
      this.$eventBus.$off("after-copyLick-generate", this.generateCopyLink)
      // 避免接口返回不同协议类型，还要重定向
      copyLink = copyLink.replace(/(http|https):/, "")
      const result = copyLink.startsWith("//") ? `${location.protocol}${copyLink}` : `${location.origin}${copyLink}`
      copyTextToClipboard(result)
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: "链接已复制到剪切板"
      })
    },
    editScroll: _debounce(function (e) {
      this.scrollLeft = parseInt(e.target.scrollLeft)
      this.scrollTop = parseInt(e.target.scrollTop)
      this.$store.commit("states/changeProps", {
        option_name: "scrollLeft",
        option_val: this.scrollLeft
      })
    }, 1),
    // 获取iframe预览地址
    getPreviewUrlHandle(e) {
        // 让iframe重新加载，先删除缓存再加载
        this.$nextTick(() => {
          this.iframePreviewUrl = ""
        })
        setTimeout(() => {
          this.iframePreviewUrl = e
        }, 0)
    }
  }
}
</script>
